import axios from "axios";
import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Stack, Image, Modal, Spinner, InputGroup, Alert, Form, ListGroup } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Accordion, Button, Divider, Icon, Label, List, Menu, Segment, Pagination, Form as Frm, Message, Popup, Loader, Dimmer, Placeholder, PlaceholderLine } from "semantic-ui-react";
import ProductCard from "../../component/ProductCard";
import TermMember from "../../component/TermMember";
import AsyncSelect from 'react-select/async';
import AddressForm from "../../component/AddressForm";
import { useMyGlobal } from "../../component/GlobalData";
import LZString from 'lz-string';
import { Toast } from "../../component/Toast";
import noDataImg from "../../assets/no_data.png"
import dataDestinasi from '../../assets/data.json'
// import Pagination from "../../component/Pagination";
import 'semantic-ui-css/semantic.min.css';
import { width } from "@fortawesome/free-solid-svg-icons/fa0";
import { PAXEL_STATUS_MAP } from "../customer/paxelStatusMap";
import TrackingMap from "../customer/TrackingMap";

const Profile = ({ cart, updateNotif }) => {
    const showMenu = useLocation().state
    const navigate = useNavigate()
    const idCustomer = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')).id : null
    const [dataTrx, setDataTrx] = useState([])
    const [profile, setProfile] = useState([])
    const formatLongDate = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
    const [activeMenu, setActiveMenu] = useState()
    const [orderDetail, setOrderDetail] = useState(false)
    const [selectedOrder, setSelectedOrder] = useState(null)
    const [activeIndex, setActiveIndex] = useState(false)
    const [trackJneData, setTrackJneData] = useState(null)
    const [productData, setProductData] = useState([])
    const [history, setHistory] = useState(null)
    const [awbNumber, setAwbNumber] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [trxPerPage] = useState(3)
    const [joinForm, setJoinForm] = useState(false)
    const [termMember, setTermMember] = useState(false)
    const [allCity, setAllCity] = useState([])
    const [optionCity, setOptionCity] = useState([])
    const [zipCode, setZipCode] = useState(null)
    const [isLoadOption, setIsLoadOption] = useState(false)
    const [member, setMember] = useState(null)
    const [awbResponse, setAwbResponse] = useState('')

    const [tempOrderId, setTempOrderId] = useState(null)
    const [selectedOrderId, setSelectedOrderId] = useState('')
    const [selectedOrderResi, setSelectedOrderResi] = useState('')
    const [warehouseDetailData, setWarehouseDetailData] = useState({})
    const [warehouseDetailLoader, setWarehouseDetailLoader] = useState(true)
    const [shippingDetail, setShippingDetail] = useState({})
    const [shippingDetailLoader, setShippingDetailLoader] = useState(false)
    const [phone, setPhone] = useState('')
    const [iden, setIden] = useState(null)
    const [idenNumber, setIdenNumber] = useState('')
    const [checkCorrect, setCheckCorrect] = useState(false)
    const [checkTerm, setCheckTerm] = useState(false)
    const [city, setCity] = useState('')
    const [addr, setAddr] = useState('')
    const [allowReg, setAllowReg] = useState('dissalow')
    const [firstPoint, setFirstPoint] = useState(0)
    const [alertJoin, setAlertJoin] = useState(false)
    const [imageProf, setImageProf] = useState('https://via.placeholder.com/300x300.png')
    const [openTrk, setOpenTrk] = useState(false)
    const [addressList, setAddressList] = useState([])
    const [modalAddress, setModalAddress] = useState(false)
    const [selectedAddressEdit, setSelectedAddressEdit] = useState(null)
    const [modalAddressEdit, setModalAddressEdit] = useState(false)
    const [modalAddressList, setModalAddressList] = useState(false)
    const [userAddress, setUserAddress] = useState(null)
    // const [orderAddress, setOrderAddress] = useState(null)
    const [hideWarn, setHideWarn] = useState(true)
    const [addressState, setAddressState] = useState({})
    const { token, windowWidth } = useMyGlobal()
    const [wishData, setWishData] = useState([])
    const [isLoadTrx, setIsLoadTrx] = useState(false)
    const DEFAULT_PROFIL_IMAGE =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsCAMAAABOo35HAAAAV1BMVEXm6Oq6vL/g4OHm5ui4uLy4ur3a3N68vL+0tbi3uLzh4+Xe3t+xsrW1t7rKzM3Z2dvS09Wpq67JycuvsbTl5uatrrHj5eXl5ebOz9Gur7LU1denqazX2NqfosyyAAAgAElEQVR42uRcbW/jPA6MpcRGJaApAkEqDv3/v/M0M6TstLjb2+fq7NZxm5f244AcDoeUTqcnemLEq7/3V2mt9LdYSmml1P5ba6utpFpTTP3/taXaGv5Mrab+ntLpucASUHwAFV4dtBJbE1KtYwaAOkqAqREm4BVCaOmZokpAlfFW+ydw6i9i1KMLUQSQEEiKK2JVGVhPFVkeVYUB1tMPYDVkYYyt9hjjiyEF1BRbHbIWEkLracCKpziwIliFQYVfkBcgqSWKsjpUjTDpIyR/whMFlTirY8SfTun2dN5KwKuAopR7JRXmI9OxKQfbs0RWdKii4UXAlIWdtMDxKIlJ1a8y1jqEREkZiY/6PEkYvRgKtWZo9adnXwQ1IesiiiJTEciB5VMvgyGFJyL4oRnW+OponTrFE6WmBETaoS4iqhBLDblo0dXRas8RWKdB7EbtsVFksRg25F/nKERRGzKr8W8iFmogWOGJsBpatJQBWnXCsuCSVlA0UV81wESwWqhPgdUgqgJ9FVu0Omi6Ab8IqJ6BpfCb6QeiRNHQIyw8Q2RtmaqYejDF0KRFlY2EC6SVqLNA722VWMAtHD+uvujRqDYaWoHYNEhRQONaoRIkdc+BhbB3hiCuZ6mCW4mlHodddI3AqkGWRlU+EFUArbPfccZKzMPnSUNmnrU3/IIfWjON1RBddFUFBGAMr8CWMARlYjp8Em4ZS4DRaYD2LOhpmIxNtgMxUkvoXFWHbjg8Z8X7HsfeQFmw/SrKYak0aGqlbjeyInl5JcwMrRxSfpZSeBrNDbIQQMEm7bnHPrA6vVd1zgOrDiADizSfnyOyoK5oYUm1KyPpNaDFAeFTVUGRMveAlmgeGHlKhsND5T20cHIx2miIVn1SszPEABHxGwkJYYqfnoRH5qzoYMXR3awFsbAJ7DXQmmU5DJJbycYTaQ2qGvgcuiM8mWhH40yMoikGdoSRySc7C820tYJ04BsyULQeqBxCPjRYNPzWWc59GtKPgcqCeKiwHXw2wXBTmIGmMpneMDu2dr+zG+TJFAYZoon6im5yNaRYFNXmsIkOrIp48J7zkbNQabgKUhuo6hM1sKkjRHARqwD9QIxCdebCH2D3/pMPi9W2bz45v0cOVDnKqcWsUXwVrXNuaHa7hJbaQqZiOHA1/OQykNCjCSxNCKPc0FSaBqtVQUZv1EqguTMm42s6NlYDMc1zGt80pUdwIZYaB2DFlhqS9c+m5aXeO13N4ai94SdXxqtg9MlEh8HdPgpStjma2lebEGaOdTz9ejXs9H5M6RA/zXHcbmgtSo6yG6y2zNAYXKyIws3bZ6aj1GiY82En0kM0MPHc8aN6gM9OyWltTutBxiaRdJ5dvLvAMrDw9xEJ/ou88rZQpoPUuhyspgaHo4pVk4rUpUIHXJlGzVG7HJ87DxvLtj/gXakAaqGocEghX3Sd5ki9h1CzYZbD3DPzuPReik9VzUkuVBCNNbBKQHD6TGFaAkLMdIK6wUqcQOzso+fDRZaF1CpKyezV1JXsK8hRs1+ajSfqkKIhrStGQgxoEbQ5HJCxNtpKbxxSaPTM4seVSHU5GBEGn4El21kTX2Gck+k2wFEGZPmYhDW2IUnr7JyxZNu1Q6XTACHKfQbWQxqAxusyG6q5WcHiKpPjwwFzcJVZtoTVwYKThaXRpnmOeJ5iNCAtgw1WQWChVbkMyMfMkJJ6yAcDyycUY8evqMvBH9SihSmohTWu2NaUbABtA68aRkvIaILAEuUfCqx4P6YXUNodRVzJkeHuGieETbYo7eVg7G4RZUNVD6pgRmk+WBp+WnQvfi5ARjJnqXYYIFkzOFS7q4ZgviiZKoms7O1Y8uq0sWV8XU1D1bHeR6OPSyGN1LXOUzs6KItoCkNzmNDlJCmHvzANSwozn5DKb9VBj63TZpjj60USoUkyS6WPKw4YoZqLHBw0TaCDGQ05y3bA51+Uhun69npbPj2317dr+l3GWhf7dCAg6qSJiQXrcyoVVkpdTLShRJtLrUQbWZPoLOEV8vx3RNP89gWmO8je5vI/Z6HjRQeZazKRfU0r2m3Xdrt5WHdq3aapEKHJYktddDYJ/xdE1H8HagUs/ZrcyxANFKPNUzGa4U7FXsYBJjevbBVLS1gyZKQcJN9nNIa920k/A6lf4LWZ4xQbekk0EC3ylc299KJs0HSiyZjp3NXcdRdYMLQSiAqOA0VE/qNglY/fQMrw+ii/MpJPKoW+VxQHUGD5TlPkrGbbamOzqFZbwnJvNFgaZnJ85635TxJ8fV/+0fNe//N8onk/aIcIe/qBsZR41Q8UmtPOdYdQTS5oiZuee/9nJq+Lv+A3ZJLWn4IqvC7/+HkNX6PKeh07llNcWakcIrAiV7dls0tdAa2Q1pNM3DXqWFXxOX46T/WI4veuZfLPg+oLXHd7kGqcxyk5bRfRIW3Nzk4wnqot+CHxmtO6GTSZpa+/dYDU9OTwxyya9r783897+5qE6+J28XMBLIicSoyTANx0t42GNGZfrQot/AMkNTSD+Q5Q8H9COnws3/J8fEVLFdBWkaneK/idM1TuqlU6fjx0giALZdVYzacTafNLjHqQScBfH5+Bt+WbnlvY2DLlNDaLmr/JaSg2ceb5EltaS0NhdRVaFU/ceLexThi9c1Y17Ak5z49Ow/i2fOPzpiWsu4PizMDEoybc+CgKIqkFpJvtPvqRgCS0ZMKk7EMw5V5gDs727cFgpdt3YrVMt/Rpo8GOPjfJUREUiyCA07YMTVK0zaGl1Xu3oZc1OVm21qzWEHTFgvhQrObl2595Y82Y3Vd8z69y+7E0K4aFOst3/HjSK9nhnCARn6zBYf4lo3e2Oj0H80Mtmu9NQQTWMk3TW1mL4JBZttbARlDDVVVCMFYJyQ6qwm2vjhen95JUsBtA7AgmfILf0zU8krPK7dvDapou03RrY2u0yO/Tbjs+pE0TF9e0NdPGnRZVY8F1WI8/gkWTzNI5CLjMPvqBYNXb90Ol2BJxESibP5fIkyYKLW5rRz/B1NVCtUGFETwggrHgDnxOSkUmJR44kYqxhymGHaACUkQsjByMbAh5Z0qviZF2e7PrUmyniI5W2HhZGt2Yg6WhV/JCSM7qMAHPef6x1D5tnk7z2q21lXfOvNTeFBa/1mybr0qYms+AcDPaWrk9m9Dith/crCz5nh8F1g5lcFq+oMXrUnzRFrnIez/E78lX+5iOTRvJdiKg5pqyAWXD51k8pkKI9zw/yqLZI66I1oBsmcdwgsP6WG0NRIfEi+31jaP1fsVMWCthMIGVRwpCtGvAoxFK/pF85aHVa2F/XfrHZcnWPjd47mwFseOnaQ4XsdI4TKiDcXYoYG1tUs+4REIXr2fJ9v7nVQA+Ig3TslNgLcJq4gdY3kaFbAl5BMDnOdhnkBWTVud9zOkpGugfc2etpyLoaqY5moiZ4HtAI9120FdG8BcWQ4uvpTIFK1f8qp2Oazb7MmnVhscgAxlk5RMKaobE9yx0ZprvM/+8PmQUFm875J8Xw8v6cbnc7CxT1ZEcs961mQyYCtcgXTI0oysZM43qyqtgFrnbLmkWeT1COrzvk4TTdFcOQVvTq/ZGI7nK9pFtjRuDCrp+Yxcyrbu2honii+9zCs5YTEabT++N1XUPYl+2IE1nfp4vl8u/dEcDLrUo2pTRQ1nVwnoh1lhDpkMDLKp6nJwl4JWHZmWZeNg9DfcohNuAWi6KqjM/l0y9wHkOrGS5onarE7g+aOLFa3hcO3BKr2pojbTLB22DMC3zA2zleFv2Yqxlk4cXCgiQfON1YXTcca+FGX5mXDU/v9TCOjL0lSxaDHlknN7JVYyy67w7Z+1BWB5a/ZtUA3WWPe88G1dNPZDfiZFfy1rHVp/pURtLrFNVZZ9sU9kNfFFw7YpVXvZ5kH9DO3SgzvgBYC/nWU2hTlHY8Ry7ZCaoKga/LiWk1XLnVtE8XFKARHq/ztZPz3tz1i6qYdRBT8LzWR8ds/N0XniHJlWoHerV5Tu26s4jOtUWR6va5o3bju+zTGRrdmazaK7XnT34t30q4QoY809s1cuhcvGd53KSHTzZDAc5sXevL2nro9r6h++Ost2h6T6Ii9ipJM4/qs2ZjNkvkzP8ZTkbu+Ph96B5ju2O6paGdWl0kPw4HeCen8riLINUOI0WEeIhzHu2O687yYbLhq26dvDQIm1ByNuNkG7H6PZfv43H7yzarCZn1UIO7WG+i9O9JdSro3XdM7J28fs2gsHgmoiRfT/35zJbDxg0iSZQXMYaN/9aUCmicrJld5Ps2dUCctFyEMKhs9Z+YN2+XzPc+6MU764ZLtOLMvH8ctNdWLpUhhjZNaPon8X22gixTlBXg6gASoTOMkaVfrMR1vwx/5zAumsETYoKrOnMVDzb62W2U71iq7aZ5qzr7onTHJtCW2NjY2iyPBUqYBNWnbD2TMPbHqLhLrKE0Mi+y/kF319eLrcWdEA1+Qmd4FckqxpmXfTkm+7+a3Iqr8GU/VvetRrO+yisaevNKLAmpB7AYhKiIp6vvJXOjofznhm/ajSPjlBTr2StoXQCMu/f1F1db+S6DrvJiT1xAtdBcdAtgvz/33ktklIye152uxOgO23no4+CJFMk5Rkpe6kUARoa0Glrx1+UWJfcUiE+EtE7y89CZVHrqfXhNx2yEkdeJh3fGEA7csw4Jx9jWs6qCRqkn0iHhpf2d2Cs4aeeRRTKtAqMVS1OqMdphfz1L+8rX/zSlI/xXIImFF18sxeE6KjjMAO/42NTsPKdwfq8BYxGSnEgHBgkCxFKEe+KpdobfUVQK0bufY3e42N8XtzXx0nHcOfquzCUvrILhq2PO7dRNP/cw41ekktYdELQBoYIWWWVOD1c04EbWWY1XWW7LOc+r1hSgw+r2jjAlcv2q/5no2G+S7Bot8DRn2hkwPZBzcpzrL+vNU27+NFACx9OzoxRf+Mq03YGfBhDnIizcI1zsN3IZ72/Oq9IXT0eXofTM42FLm/ZNeFkLOXd4PoPTYIrM+vH0222AKDyNIj0k2Yo8euCHxqC1e4J1r+v7+2PS8OynGK4pjNUfioCcNVhlEj/dPGAqHcsLq3jGrtMWKHIUXnjmVWiSBmr9ldUIaOVUrT5ST1LMCsRlPaMKuhZ/XW7qKmqQKDTUW4Gx+5SDMVgrRGkk5mx3t5uHKTfXtvaVYQsP6fbizoVWpYVYUEdlqnY2w61enD+Hd0u8yP4drJXvJpnDPOMdlZVlJd21drYUIbtrsx6+TGYflIIxTbgCCw6Bu0ULNa5kF7Dx7kUxzDROXNy7k/iRI4xEC3L4fvY7CAUKm23BGu9EWGlQZzMpFOQIAtxShanYkHrR2IDu7COV4Hiwy0gPgtmwK2cl8zJOay2RO7NT0Lr8cc9Zbi9fCRMwZA+TuWLdWjHX5kItJLK0X4/KU5cLuD26rvm1UiKIeAnPbf2tglBOCjN+z2n4fvrQYPTo0opRItNHdgK5Vj6wNPDVhm+d17h96Ert0en3ld9z4J1rKxzcXSDkXiHBup9tF51oHEdOAzbd29ZTyMORZyADKD8Kked4hhrQofvkXu6QjO6u5YI0c0ju2DAWnOw7qg/UA2EWBardhx3BGt8ZageP9EyRvSh+ozEEmQo7PNWimUGcCi1lOb6hE6/RfL8qeb42RdCtIP3doHuWcjhJgTfXtqxHs9kA0HWRFyK5CqksYpgvCVVqf11h3eGg80P9/ghsTL3nuWbCebP+vh4mv0QKCWXePjvzDhcqi9dB0KLEzG7c/CacibkFF/LG+8Rk/Ala62yavE9VfCiGUk1XjdPgpixYNnjMKD1ffv7cBG+Qr9JoXwpwYRJCwCpvVQOiSW9C4+OcYvfRzgaAClcQ12dp3FuxqtOcerdCm+O/TsfhhdChn+WUAO5GGVWQdiIR/tfRd/iwPN40r00FDIwI11EmV2eu4TBNSzeq+zpUI+3vz1/28Pw2tZTpNUJ3gkcABo4+kyswP6CKbEWZ2bWy2WjFhyn3DN+GMEOExb3ylDU8c7eGDErwxtOw48X832PJFvRSSGnQKCQdjDwVHIzxXAWglXzEjyWb4SLzjptIGIaVrb2YGWiEveGaedA5PZvO+w8yznJQWmaguyTmFORWz1gFdGa2OhrqQ2M+6pbsIjWl+uieCYnunBTNRsbcwkY4tXBFXQdwKwbMiu/DGGdPFZyw/s0nGJqcibZ+lURgO8/tUet46x62DS4+JcFLLo8bPmQnioEChQPQ5HzDPZyZIekavIWrxt61vGSg/B5NydNsqypv1tnBzpF7aXKJlWK4wc8tviuL0upbAajxY9DjsscC8k65EsFrjkorAOFiP5+R2btL0ms9LgchelECtMUDYz0DKTCQTCr12LPqzJbFfZRetQ64Q+RDXmRRC/Tmo/ORj60TBsIRVUn/Ky9HyjHfEuD317X2k8lBx6G6PGRZ4mtfSJLKoLGAIRV49uHEw2+m+O3syIqwPAGH55w6OEkgzGkfGSU4L7foUhvL2jt/xW+HDcgQianUrIv1KDt8FMh9rQqdba3n5IIdXuYX/t77qcCPaza/iKrjIQ6SGEJwu/sV/echtsrcPtl1gmjGjsWx+eBCGvSRwj3qQOsathhtqc6f8pjyzFnWVhufrvFqDsb6CmiMCHDTKD3HU3+sNQC0Pp+mTU40RegYbqoE0ytwiARxGO6qQiTUmyuc//3G78WzWJitSjFWaQMxQkci45Fx3ymUxPtfrAM8fvtgjU8eRrStQaVRVShJxagIHx1VFrJz1h7n+unbjeMy3+5Ts/TLxgamBouir1ae4dVmd29CWod369nDacX0kfo6TLhkGu3mkPwBgXP8GgFgOBvtWC9jUG3h2d09ZY1CjXESCgC+dAo7ahBOZYBS79XsJ4ta04xDM6OTgJWxT8EMWoQ3n6s/qqq8ROCxYdfOsAutax5jcqTcSbcao0iDt4dwOzMqb3lLd/ClB5/dgxeNQq39gkrmG+UFqxJWgXnm5ocN9hRiELseVa2MUpwPe+zzb59mceLp08225afHmzthkePrW13eErbn1ZhIiB9pHTS7lPgT2IrIavEUdATrucTIjbPFKXdV8RvNwEgDcxuvvbTNIroHUDvDt4tsXZmFhJtu6Nn5Ze09wdr7xEnIE/DadA4qOZeRF5xfEao+tOMBDucFD2bOfdyVpoZRj8Bw1xERqZljc7kR3sRHrn/tf2GYI1/NhI++YqmkL4Kc6qEfQ1IHU+VsWL9YYzuqLSHKy+6OIUAYnTqShfyAJDKO7qyXZHEsk/HDtnCQgS8te9Hh/DfxkLzsxNy8MY+TOFncAAhzXAGeYVi1OycLFpKr7K6Am0xgV0Ng2HmBZGk+RyCNjWwwxUdPnpC7Udv8Baz/Y7M+t/Xg/W89ax+dRLtUzrHZ0NaRFXILDEz/TS0SXq2j4+4oPVDdxDEXdzr6EYZ5A+a+6rTECoh0EK283Dfeqi2nloWr2/DwQ//9UJe9icuOZXoBRkoU1DLIQtfiBlQinV+LLqDhzJOzpc7i8DBo62P+WIidVWV/BXf9vLrnevTCnH7Joaj8/qBxxmp4Vz4GgBAXVcdJpplKmSKKjrZcLuxM3zM7zEEasuL2rwubpCtCGefkQxs9YLvu2tfwO32vBvYukPd2b4IRp/MfdSeOT1LQo1i1FkoaFUNo1p4rCARuN7c52n+HEN5Dk2QF3/I9u4QK6SJ6FcHK9Eg/AHaAY1ruyNY+avInQO0evvgxJX0Z1O9HJEmKV/i3CuDxmjNOA77tLOtshctq2/l6B6Q0z+al9ZCKmTE1kO6aoir275be99v0Q1/fN2NnE45dYoqdPMVw0MqK0l6tkKkEQQpBu7BCrHj0uBjlsvFH2M+1y15YQM9IJidGxGWwJYNPL1dWe8yqHWTyPrbHX74740pVOlLIrDSLMhTUJxWkXtmYtjoCLGONdeOKXp/p792wSLO6Lc0cC8HNuWLH/lJqxctg+prxo9uvQg3w1m3BOvt8eXc8rF58tbOPYqSaIlM6unoVqnyIMTgrPEZwcLf+7jEYs4yXvx85i+K4w8CaoCGJjV1d0UH0up+ZBt27sFZvzsdXhdU0+lqmE7hWT4Qxw1RjBaiWfABAyHPQcRsWxeRMouvx4359Ne6DctOQAVKhMxBzf5oqsCeU/az3dPgf3fL6XodXTiLMOcMoTkXyYMwMnDcKWTfreSgGxrxPmOKRpbhIrqQ7rks57rzeO4SnieiT4ZNgNS62JYtoToy7dH6vAU6/FbTAt2uy8NAN6STH5X5Q/s46lQ8AguHaE7S0CfsUASljJgZJF1HLWByHSeHr32NLdW87ga1jnYiCC+/DeQMBp7eugxl3bRvuD2+mlt+0Rr6uCVXSZqhC7MrGAeboXUCTpwFZwtU6oll4XozldDqbjldfryGwPMplNWmlZPsc3M7NBcauuqh2rYj29hzjw9+/RIgjRsbghklEsVwUzjsFKdGpeQwYNb2rQJrYXPvpXiM/jUwq0A7DNyZY458WD4UHs6RurEhG9FgL5udiMdGsPV5z6LT70mEz+YiYfYp1lNLcgHs5NiTOCwEbpqF5GfEzprWY9EVyQ4YdIXRufe8ajEg9k3EtAfph5xCzEjTHNtNa7/bb0OGn1YJtXlpUGso2jZJrtEDibL40kQK2SgsxGm2xKrl3R1+Wh/0wdntfed2XHPWnZjUBpusKgQobUBZm6XXPQ3+l8/DZ2ttWGzPfV7RC6lMchZV0e5FdB8wFuuPlB8PxEa5cPVW5VePorm3y1ioFQrAh0actVMmtJ61HaCTe7BQh/cE61fPw3Cr+XWjunsAz1w0MZVC3kcX60ljqWEZU4pX47FmIIlaH6ssV8TwC7+IAm38nHTWyxGYJeWgEHdr6M36VAPKst6+bfdQNL+KSy8ivXttPcGGkJ9LKF5aoJjoWwM9ykDNjNaMeFma1flTeEo2dzBYi8fpCkdNpoC7wVo6Arb7eZgtsQxk4QGsdVOw/vlFjPUMGWLrcijDhU6G8yO5Vl9c+KqUvmYBiErsYF0rjf6NhBQHXVZ12u9pr1dwXVnVq28FnbWTbLDOZRG0tnVXZv1Cix8ej6drGh5+FkbLKvL1Bbricj3n5iLyqvCTOUF6pAgc3uTAct4qEszS6bJTH9BdhrXsB99upB9omYMOSSP/bsusX+Nprs4G5dbEu9Ycv5fTKlNL0X6hOY4qqZhTrge6sprsz9lxaNANARNWkqOQCUHHrJeAUSVUMRKQ7kCjxin/n7er63EcyWFjx5/xOVUIgo5R8P//nWeRlMqZ3bm5FyfbmHTvoyCpJIqi9nyZZ/11z+JD2mms03qfUQBdAH4sbsPa9ytHqiLMrIE3IFsB+EN+f8bQqy55+QLhsnxQG5YU88Hi9SjcCEbb6VAwmxntMmP9/L9LTBVm4Nxr5mMYvCuif3Xfi00gcvtEU6FaYJVl/tW7ZC0fQZfvO829rD9Mwt9TbFJklqWY4xiAZf5kb2F20OGyMPxr1mo+RNZCve9jnR4tTqMavhcTK5oceFHHxpA9jlVYq2WskEfRSGchxa/KWiAUBTMUuZbwq6JpIQtSTFetbCjbhWH4l6ylgmE8LeewbD/vqHZzjFSZyvsARsFRNjvBpZDvkd+PtDX4fvjiJ42xQbHEqNDHgtBMSWQW2e+ZWkZHUWVFu0Wewq/oz+uM9b/oNE5yD1GLKrBGQLSv/CJJNaCocojGxjmq3pGsVlZbqBy2pa0crLidsxBuT/jL2QywDRtCtoYkRRb0N0d2HzQCs8+WS7nQWH+UKW3O72BfNQgiCD966FVbqqujDGIkr6jX56lnRTrxM49BGj0bKr75/KVUNVMW35Kz6YTNUgdk9sO/jrLdfsxwh/XydqWx/ojUNOeVgP7EWZubrnHiFRE/WzeBrMU6O+rAmnRFomKuV4pnGJa79sQHCsu0qV2cWNQuNV95cSXu6A6YAURbvIVsnWGomFdcGYZ/KB+ajwa66rKKiOVtTi+IwdVliLlPM1voaZo9DjsGIMtUm0OHOt0ded124pYzZw21VnLEYdAAjAysxMcwOe6On2xYjX1daqzXnzgNY2wRRhvYQA9S+4Nz7zJ+1gRafeXdDpL71K2W3ldNCFmN4tMPVQBkqGz39rxqsiv+AqBx5vagsc6e5Er0LHMzGOtaz/q3QGwq4DeeRoRwrI51qMaq3jar29G0fo5vjaHZ56B4WKdCWSfRGtTsIE21np9OeIMwGdbtO7wpZQZi1KIWhHwMy9UHP/JfCGtVpNzxGdnMVy+1mCozcdolFhtmE6vgBjyE88NDUA1ONZdQ48XRhuToTBkc7KNvFfaGZqQBhrLi4fCqI8VvFxvrny/ix1pO+JXPVbWV0/UhsoY3cbawW1mP8ntafWb/H/aDFoQjBRvu9Coum2D0TD1Immynf/laQHEKt2UtvIYkzQjKMgfLfA73i8PwX7qez50cv2xCi3VkFjWu1hAWI6VPBKyZpYK5Gb6Qssy3usQBNBKVuLZLFO1DzenLULcmwlJFCZ4V/c4IRFGaLF9tJV9urH9JW7+J0VWFtVALE1+Nz1/v4+cAZqZpJRtrCmMhu++uqMkKK/m1vQr6QbxPRHdS/ZDc0QsCR070KHsSd/Ml9IZWZCEULzfWuZD/fd+rC8gvqvc58hVKKqX2ldUV+WpE3QmMTnoFzV4Z0tF3Ve+8hubOlZyy7UQstDWCk4G3J1gpyZ3QGdocLMtOR8bavmCsjyTvgPsHXQaqtQQafIMJMF/neaojzo7eEINB8UD0DCK3T8/Br+75ztJSF5g4pFBWX3Yf1hfio5x0Ib1/5KmMqsE+25c8K1g1vx/MOTuUp3UkrFnDirnz7QBBohOXKIiQyrnwEh6R+eQqzuBShxBIUSBacZq8y6nb9Kjc0QsOAEOtgMhEGVg67Kiusgy2f8VYehJVXo0f51+6/rxJ3zFk7XUAACAASURBVHdzkG1F6Qu5FOzlHD+d24iYO9PV+vRFQsHJ2FRt/b6JrNYOQ2zGiRBp89TCOY5lKRBuUa3zv03W2g/f+o5nhbUa3dnrP4YUroflmyaMQkpi2V4OhBomYFerD+iJH08+rGeXAzHNwWWLkNdTaHBXsC+R3UdhLBsSmqEGkD92FuyF7Y5FIqylr+8Yy6z1qe8U6gP4mhtykJuuq7wPRR+CUVnqsNzEADz8iztNnFE8/UqvVLdPnyrCI1g0eYFqmSr7XKeAsJaIJaMtTJkOBjul8jXPOqz1+Bx81Tew60OIR5K/s7TDSNsGabt3CAtz1Ang6DrpKfTumQBp69txPjAMqx1Fw77UYY6q0p0cEKIyhRAptyqQsTzDf6fOcmttzW+rhH3/MafvXBGk81G0ZEd7R2SOhhrLJgRIwfWDteano8h8+XQOrRJAhgDbneDH2sE26suQLQQzZoQwUEKDYxDNvhWmeBqsfCsMj09h4dCf1BqamKKeSe4kyHST1QmzigcXAmHHTM6aACxMCXWqnlxIP0Ghw7N1i1As5D3w0YXITGGuIm3N2KPZgGWzz+ZPIbL81zzr9mv4UA9zIazOzdSQ2q746yRlu2o7x7MW1nLmiSgyArMsuqXqc9TUnph9YaqdQ/pUV3kt9jID0N9CCztAM7YjYIbLqOANdjj+fXzPVrfb/fnbYk4XqpDk25rNDNxrulVouxYn5i7APtYMK6uGdRoHqGARmOFmHGc58Cxixs4Q5eIJArIQlaGGGGmjjh9jPGGVOyJwc7cyL/uKpRiHt9f70VQKdyi6i7fmD2E/B4dU+UpziUmUBhLWULpPT6AMUiAY1DvrOWwdmBkq1q5qdOD60rBTv8geRcJ9u345vG0T5Hd8b2ap7SsJ3rxK5rql8VOEoPFNr1qbUiNF1DWtUeDxAx9ymlZH++a5yYNPJ4YqI+1iv20sgVXWqJqbUPHbmavMQqRjwbsAjbpvFTaHh9W273jWTZ+XhaKoMi6HBdkdn9eH0KEqLFMhwJzQ+NsrnQsAvJlrHHSXiZKaLgW5LGmI/YnQxFq47cX1+rR7s2OWAuLHRsdIyonJKmuqUxSJ2yN/w6/MWmGxVxpdNIzj5qD4BXFUGHw/B7eoE7NhlWSDRWCTqSzTxg8Bd5Gv6v6Sd4TJf925+szFAFJkrJI/wzFmIdD98qk5zN/1q5tdL37nMazVaJ23m0WYiXQVduK+ao+B16TqwRDk5a5baO0Q98QHhd79fryJaakbOXoHB+INaJpLLde9Fs0JOIMi0JqcQsgBX4/tGxWWW+oGYx2f9nnSz9QWtBlqrYp9mhB2VXiUiyYizDwHqYH4NOfu0JX3OPcKXqUoIMyfFmLJRoVEJWrDejbPKXvGQoejhhAv4vaVBP/hVzceW7+9b8uTqb3xnfrOIYc5MpbknSy3RwfNQvRZdFhhiMO8LolVV1SV0UMthQiyAAcEYzbQPWuyk72KryW7R+XGAmJ7fMux6FS6TH/891oeo+PJVLFwqQvfjYuBl03qEY/c+Tq8aol1y9PV2QG28yMBixhrTu9LgcoUiYAMZeCyScZkkHUoqlMrF/ZcP3Srx7Xj+/CrXzTWYapf8Ks37NZukrhwCRCvEuhZq4bP4HwQfT9+msciuUMKlGNtgpHnssiwpVJ85W6jJi1Cs3aMdLChw6FETqwfwJlhii+lWguReP0o7MYyS351GOoX4vBwsNvr552eYq01RGK0vNRRCatH6iLSh0lO98y4jdbGkuoSV5lkJQEPex04h7VgLmDuooxaX4jYYz2K8t2Mt2USQQ5vEuBgf23X1lm3WxSj5lWMQjjY6/WDU40/73t5hpAtqwU+fiQZzd3q9ft6WOp45XyTvnVGkY7OirImQvKSSt0VV6eTqDqahC9bTYUUVfgCWuFglIZ9C3cyS24MQ7PVtb2hG4tmkq1u5lP42Enslx0S3x+j36/iU+jDeoiscSPuUXQ9FZvOdwh/LHG0UUUnN0/iPKGudbC7TpLhQZ4iwTZz5ST7mALtIat4Fu50Ly9Kr/SsU756/eIv8K+XZS2a6q0L2YeD7dtzpDhD1eHpgLmPz6202rP0G0wcogYbuV2qAk/dkTvdrfKNL7WG+fifhsSAMgO6GuAF4u3nOnRzz9q2a+us2/kpNLd6y7/MROZQdxyJ+7H72G+7Mfu+H9XP9nw87TOOxz/HA0RVlPbHBVnv9zZOK1Dggg7VUgCLGd4GqQmU93TSltkhnVIkXEQQSzkddSn5kBpUqNjKj+LP4XZh6XDz9K74U+zBajgdbqY6DGQnxF843IjD62+dyf7BUVAY6e5n1xdXGuVtXrsNIEBmGM4HTkLdKVBR9c/iYRlGmhONw0U5i7lUEHBWaG0V8FNJSt+6GpZR0W7/vK1i+LEaCwnLLq3jsB5OPCvd87ilmeiFOx1wJVcbpaS7jjf6kolEbNu6wbSEKk/iWo4xaymDRU5DEXjsj2BRBlMZqlrU3G5jbofhHpeVDjcVpL9UuAPNesNItx8zm7mUnXhWLJrpDou1MN/9hzdzdDRu4VGA+EBtzfXCdBm7DerakvYWGB/1LUQ08vy+uwoIRoXqDc2d9lJOaIzldqV2JCt8rnoNz/0gs/obwWcmu6e3shYNhAOzFpGIQLsNylPPdgqNDaAE+3TWRFKQ9wylXxcrWpbT4tLpqoIOyHmGJ28NpVVK+qZbocvZIs3rQdz0Dm6P7So8S4DMP5ud92BNzpjvVpUe7vPCWV45E6Pw7qay77aVPjKvXUr43kzz6KdpfGblqfSh/ZFOzKL4y8UOBSSnzL2vQRU8ODMoHTLbac4Mt3Cw7TpiSMUZlOHNp9Jz1KR5fCy6T29eZc71gsl095km07nnNkQhIxb3p3NnrKZfWu0v3cVxj0FhCN8P0h0QuYi7E9hd4rRwj/GgatJSK9PiznWNZ91+qxksXb3TY6yLAcfnWewRpMVwfp1XLt+8Y/Jjx+rfP5G4gFfdKZWyjUFxwGfc4hTTieleawZlKpuxlp3K0qSuIWdxijPQNmnzOiuXajAGYb7Ks44OUOUoS6vlMfrSVwMUxuZe4zPZffr/0nZFW24qOXDIgGnmNhhDuAGW///ObVWVutvO7kvGcTK2Zx51JFEqSSUDEV80jWV7HNb74hHjH37aRAK/6TUvbR7ISq81RIyFnCJIXVA6h6LPf3ArDnw752M4FYm1S5+WqcCo/u/K8fZv+hu08udnRqQIxI9f1wI9mUpK2nfkUtaBvRB7Slmmd/9LV+N4m9dh1m1frLsaK69Kryj3qg6vo0l/FTL5cjSKfa8LRSCkeJDFr7PK6Ln95ZgBaHT/OzlLNEPJWF97z5U4iss0Pods5EJjhU0q+/7BubhfP3S98QfvgXqCR1a/z1MPw4zuVjG9RVkroovvNxvvhXKAnjRPwXBH1ZwJw4/+UDxPT+gy2O6ZC72wOVnK/if8MP2lnPXByuYTnFWZSG6zIDK2TDo/dIn674a0Tszw4189F82t7qkG6rXy5WvQIUaPxvQtymgL90wo43eh6DlprXseQsZM30XwruGG00FoRWDNp89G7pOZy7DW9FcKQk/xXxMbqq0umzgj2knUgmtMIzfshxSUy240HE4j2ANqn1KNGNpqkyLm6BuqX6NcbI3LdasOMjG7W1bXSr3RMTOQqA2EkGtQMO4ApHuhZ5Sqkp0AStPH9H5bfTgv8yUmtBpWgwQIeqijC1xQIWXEfJFxoq1aXkHyFmOZsB2LY9UJK0Z4VrLYusa4aEj57gtNWjSZMQMyc8AdnB/d6Twrn3JbnZPY0eRZJ201v91YNWyY+zw2mge4tWs55KGZSudphNaajTUEsKOwnYZrtRagTblRVlpjdGul73gy2p8WssiVjC2FIYXeNWLLaYbLtyfMj9V4vsQzAJLylRKWudhf4mV+3nreVejaLMfTSq9PNB/HH/1qFVVHNSZD1h0yYsVE4fdnYGRyjyuzWDLYkd7iYPs3WYvOFVpPnu4gMerrOOUhiEffVQgH2mhXgrd/bwaleQLka/JZyNYPEvowlrADdMI03dd10oJkIwcjRW0rMyEUmd1HahGMVeZyc9lrRTzCZj1Rui8Unuw43zjYcHEMBNzotZ+kZEokXl4P2ttp0Tcxx781wZfEfmr1GfvgZSa53FtPBvKR9zJByvYEkxWVUtyn8rZ4nbFGGklJK0bP8chcYacOyF2ChzdKD9CCZBrwFMTG174zw59PzS9yWB6Ds9nrzUMN9vp3qc4XU6qh8QWmtiyLa0kcsn1D4xIprtMwaDWAeMo3mcZqocLQaRzgZUdELEYaij7Wg2i36IPaBYciZ26akMbiorgjUbMMk9a0757dk6WSKU+41vROnPUpc936vBXHpO5Do+oQdm0WEFOywrEOydhyHSCDBY5uj7SOJbJYWwueFQG6VrjZGpG04rGua9g1+oEdS/SdEYmcRcaO/exdr2yxDBnIYLlrmXctb81ZTFd7vpfTSR252gqgFF3jLWfqYvkyIbs5rSYiW8Tj6DGoeRDmKQOiSOv4pMWSpQ6LwbgycSV3W0iRGrLiDhP7zUhhM1eZ7rnI2TVaxBpnKkaa9Dh8L3R4mYQkulIIKgjHqkev++uQcW9c2J3zH1k7jFI82cOen4YCDngO4i9mqCPE42AsHrFzeQsf6LMxrPnSNGQuc1gcFsAFchTPP8AtGmpZ3mgs+NU//cvUKB1LE9s5+jgUKeVMhw0DH4PcFx+HkszH8jW+lM/0sIOGW5XoLQYZjmuYdWbIZ7YNRBAxXNlYYt/PJ6ZhImZn/poA5N/FwSu33/M8ct9VAn5NORdgegQaRx4aKjRQUKZ1wI5VVd/1CqUWDOOL2SJBAxPWGhCAeBam10GjpT9PXDShEgE34y7ufWleFNoNTzzDzCIHyMrMtdBo0zK9z68+fs59X22ZUHug8a2AxpM8x2RMs0ixRw1NjPRx2jZ4fh/LFoUnr7GqB0eDVPazrsWxVv6sKRi3ZLV1mW3VZBZ3hXn3e8ajeykHZ3mQRiLJ+M17SVjvy1mWr/a8GadTlzz9wqFtVoI6y5vMA75h9IOzqgiDr8RxMBmlToW0CsjyajDQSHwU0lwrktZxEEes29az73xeLrbGcSKS8LNGkSuAhQgE2wdixoxlBf7bjAXUsBcVnrLwpcPPHQWRG9fiwYKOy63lNMVTTHnpMshuVTkIXDW+5nlk80CQZUEYVrqWWS199OCyZiw1nRqJrPcIC17IMyB7rglF0BDHvy1n7S8KBNXmc1ufVBhoqqYSaHD1nSCtw8AduQLfiUXHyCQWMydjdTN+W1VMr8QN5mNwr5S8kr16WOdSW0drAtICmTPhB1R15uylCGSOn4Dgp7fZKsOrvvMIhDYy5dzb54FkAAgjGTjiPkqwYYRUOVd5Q+1UmWiQN61eF5onEbYHeFMUUZOehseWktaR/GtdF9ANXBE3smb2mTVM0MxVs8vS1ekQy91rmZi29rfEoO985SsUmtpuyx6TJrC4Gjfm66k6DDpq24QPw0Jg+Ruz/ZhpP6dGPYHBVIay4FoGtLbN3kIymBmuv5GcEScDy83e9KoGspCx5om8u0XgQjPNbwtD465qdSe/dpk1CBxvSZXOwq/xSzChHaprxhLDGtvgeofhlUamQwlimY+tlq8UiIf5FeIvOVn6sh2b/XasPZM8h0GuXcup5/xMJTPFT2pROEHqOestnvX5cT6fm6X+R8PliU6r4TpqooKQjN9IVkZXrGQrqbpTPEU14QsUDaJigK/csw66FvHVEWmxDakrfSzUTZk59z77kDtnujVdVPNY6bVMs8C7fXyfKS2lc1+egU2T9ei8HPQTMPYjSciWC6rJWM3oD0GIjZprdTQUvWrIoFSJPcrVcjJnpjK0hfrQ4IQlK7jV9jB7bYeVzFyov3NU5jrLcK3m1ehOc2H7Jthscmj6hiLnRz5uosBrGlejazOB1alZoTPProc1UoAHhAKge05WIRTMPvxW7DgCDYeQKP4dqHOOlLCEHRLMsr+mXL+uk4octek5XcSnH+CniBrWgvxwq8G7pm/3DVNu/9VXUilFWybfOcmyrLz6PFCbdeBhDtxekrKTTkA/c3zD+DudHFU7W8DRWl4WBpQ6a2DeOlYAiM0c63GE2efWiEpz1Ww8ze5oIRNZ88TW6sIH4TugQ3Ks5eWoQufrg01u4Djth+ReLjh69QxE2gYuqtLLnhBpZapYEQ4gY0KVv3K9EwxfCWitx+Ox4TVcvooz502Tat9kcjgq5n0SyCLSWhKK/7axPubq8oT3U6uDs4VlUEPVh5KNZg/cvzS0MGq5XrJh/7tLMWbj6C2CXViFrsxEluct6syf7G2Lj0fKW4a5tuW8+ZYJw+6iYEOpCJHJKzJLz8FkqO/yWUju/zBddX3Rv2d3oi3wnUruTPJZe3uUawkr+IqcVIueLDVWBWE2F9s5+LTkRKsBmfIZCKbGTIb0brDrkayVR9Tcs+5C7149Z+wu3o8AKxlr+W77/rMkrO5Jr6HlMYU2C4d1OWdxs9e7qrIRE/zgDZzCw1TJ3fxojHou6jkoMoa/WbZH/CGnr0DvyZ/SC+AhfUTfX9pLbZifheVFu02Mw3la/PvyfeRenX4unWeXSc76yBJ1HwZleR7Zk8YT9nkdsFNOGlYaXtBoKQM9pysoFZOApPYYBGYwu22W3TfGYfroKQ2ZVS0cPLhDaaxhnoS09smRwxsomtvT3XU/88WhBp5fwgWdwVuExrl3rRhRNSlGB6auauFfxlDzV5nwC24X0Q1wMUvpKfCCoQaiCIUjAjHZLpnLvGvyHsWpprMZ6dTqySzCXYSycPu0+JfpW4D056sqnaYZpB9Nmq8DDpXAkxMNuoLWDjoL4+354Tey/WkkJKLAAUYIyusHw9H+49kHU22ocuBbj8PMtCIeDwvEV3bmFL/AStoHjLJDoUJMvy5/3r7n4vOucx2Svdc8A5RseRegsO/pLbR+o4oLTJz0sOfi4Pdywlh6qr81KEYvCg9l+uh4YTWy5iAqPQ6aDR6V3GxDgWi+lTDEY+v3u9sqEzN7aX6hLlSRs7u9loUVz/5N6N7gmniv4xNtVobsylvrlSH7N0HrhAYcqlMdyFY0EE8sPBGj5bm4Oje6Ejik0GOD4mBMbsANyO6MPHrVgZ8twYg9LxJqbWKmaAM9i/yCUzI5EpPllj/n4DGutjxrSaujKqnRakqmawfX28YNCtTNo7r0Y6tbTOJGTf9w8CYFGb483ReFRw/Sx04kw9fYN7RwJNtAq9mXZCOLwPSeXOsRyL/vczUGqYbqxOfgzO4Ewm934IDPb6SsW/ekkOxnVPP8aD7xNeBOoaSw1J7g7biWssithHh4yjE4rUzQJdELNp2DNQaZ6A/vqIr1A5A4QGNZryKhhpSvzGgHHoR4/Sd9WVyUzhdzJlaHyO5z8St/yWS2d/XnM1g/lyafceyKXopv1KOw4aORWjy5eiYCVZMit27kThWF9VznxOAwVKn+8LYOw5KowSrnuNI0B1/0spTmN6t7UmiepfM87U5h8enHUVvZCNBKTjXB1/68S3gVZOXDas+FTrkvJIlkuZk9HAfypRgwGoVGh1AKndFKm/xcdLYvrppZO4I3vLyxCtrKnn8rPclCESwNDJW+yFIpFpfn+W1P62Uca3eLKQz35TvQARO2/dPdZ+88FwGepkjRsVPfeqYyBws6aOLd+mHIAffavnlu5AAlKE2Jw1IEIqs73wCo8DDg8DAjGqv12OBdjyMXg7M3nwUa9gw/99xYnfztTzzLB4uuzLf3T4fQGolu53vPA4/BONVAlEWzdZTsQ7mjyznh/435ua30IGSWJ/FO0PBfzq5oyW0cB8ZlaUfclXwmaSXS6v7/O09Ad4O0J8l5MpU4zjyiALDRaABeDu55digKftRcyUG8xaUBh9UdrETvOZr1tzsyedlkKiupS3sMHWz98WCOFkOOrUdPHTKWzHTnhdoqHlSDg66igcwScmDwfVbYLiqfpZyps6occlaVGIt0w77OK4pnBKXSFT7yLCx6JzN6l1jGfKuvbzrbnSFZ/gyNmmON3WrWlrQGpSve7YCGQTfQYv0OF/m1kzAvZPsn13JzRdXMUqeq3oF3VTx+p3eZfWo1vwKAP410WOoikigsCDfSWK3r1VA76VHD7jLd7ev4CmLIcun2hg2XSy9YG7Vl1Ilkh1dQq7UlhxGOdiJbHS7sEEudBmtohur4viYf3Z0Xdc9yP2IvB0bZaSfHWZ7nc4aLTZs4mfuNisibyuiWt26iZ2CwLxvrqqGAv14OyHG/k1U6Y9Labdrp/A829cUOP/FZFBehK6jFdMtTXhdUID41mAW4UCuj0RGVs1nAoZ7cPVnt6Fd4FFqyysSl+XStkMuQGr0jADeirELa3dK6567y9QR/lW+Vdomp3RdiIyfh/DowaIrlyDgIyicROw+5odX9Ki0xN9Er/Doe2QUNlYkLnWhrR3hfwjkHpxgqMJYb6zQdDbSGV53WO07XanrIGyjSApTV0QxbexqLl4flj17C69/9yVm8hZdBQvfEW0xtSavEo1NbbaFAJCGTul4O3Wp5hqOQuwOvuxxrd2bGjVS9TvYstYJ9p8kMMDirvNKp/FE8f7OhIlQY3reQYwkq8GlUxXP7aivsGuO8dzlUux43pLFtkuYSi7ig42eqBondJ56q1zZN7lpbniQNc6g/OFcI4cfODqF+HFfNTlyteg8rSsFq6R1oy4IxE2cdZrcPEQ3OubtpRDfIQh565cYc/9VC+tqAw0fnVaNKaDMdD5xoa9GiE1YaokCaQkcsIEPPYaUlpicawnqaCKhSrOHH3kQSVhaVKxI8qsGqCAzkoLxVQwvC6TjZqtWFTFslTPUViqabEf/rRYUVJfQFkzhjuy806gTMAJEfyCzGWaJkbVkm3WTSVBxD0F3NU/lEvs/Jdv+QzNYLnWwdCafe1fkyA8I2FouRtnKkeAu+e5+ZjEcGfXV+MSMVSLrdUvbfLw8F2N9b9CXaYdBhbAACU0tDL7DF/qtRtxVwUZyarKbrW+bPkHSiTSb6FJM7+dGZ5fJZ/Dli2FFCO9By97J38PDk7skK33Metn83NewJSeVFWw9IEYisqr8WhFehd4Pv3VjcEDfRdLWR39q5ZzFYQKMTJigS6Pb0zIwGip9fU7wzVuh3ORj1ImeFYsZ+ZdnLoWlWn4I5fVeKX9cDYdk6XncF4D2ktgXO5M5W/KH0f788HHf++x9c9uL11KhzLpexK2/4IsZJBencJ1bNEzTJy5Os4WXmK1QNVYXhNDnA2md2wRxh2c/KHL/OGaxMdkSaV1rJDHUY63B+5vVM8kXaNXXnVeds0aFwEVshrvgCznpaPnDTNfEBI6qXOElIFnnEmXVeoBjahWyChYGAwZdpfpK7SyozR26nbhQKP7jRrBa0BeiO4hlpHUjBAfxOx/L6mcnKwvC01zGc7+AdLfub8CgkIc1YRQB+w+qlP9nV8MGzcUOIZaTvW1Q+Q4C1jHGGwid0Upxhcuo4gbyyNP4sRo55LwdWVXM5rieSzFZkDBO8PYMzqxzAriyPgvEs+o6W4POuRqpkDVtX5tzNj8q9BxHb+90dre77xrfw4zJ2N2Ecv6M/Py4JG1p1q2OKs7yopcWUdtLHZRpeJydqVxFK7gEmC7SoS/ugiwTfd8YfCAZzKPs/CxwxDQfxqP3yOMy1SogZtgg6AfabE6RF3kWwtX3Vrx6Px9ZdCYBa+3LR2RctzjRNEUUNrVfom/sGLRyNsfDUdVL79vPc+tFqPe+1s9zKzhehleMsxGJG2RwRmWvAhkOf60f5t3Uq4t1rhU6hAYto+TfD8Hrt18uUSzvvdWkzzylOwGgpMiKP51MXrnafMPs1hQqSs72f6VGpZSoH5KowlpD7TLrK/jAmGYOisIDeYaEOoLpvzRt7hOx+baWLQ2B3wgli07ckR9dwLd+G9b2XNVwGbnQfQrGNkS/B9TQMQSUnymQEq4bWdV46wN5/oOPlkIHf2K13Ysbr5p3P4FoNIFSg0Z3lTV7XyOyettxkFoXH4aXfJqF7ZPSOdEClQ/T1Vm2o6pmbWU/gAMHa5ZLYT00UicKzfOR5hMp2aY0vvy3kyhAIRd2d0s82pUQITj4qEdoi70R3xN9OAaSbK1cPQpf5ZfbqgULz2jK9Z3l8WH0YcPTeEhOZP5Lv5U7I9TZFc316DLfxo1tAAFZmbIvKLyRkONOrm+uj2CtqbJ3BWrrOYC/Fml8lM3v0Uye0Uh1nVciyYKHqQDSvAhFgFzIZP8/39LDD3Oq02EfrOkfvmYCdUckyRy5XvgYabFtfIQLt5UXQI3u7GWE42TUKKW1HcA2ksoin0tKh9uWzcq1KwS2EtVvsTTvGJ4DYK7mYGY0I61XAYiwP+fyduOHI8RYywx/HJGp06xiHEnRW4TspXvkdnBWbeLQK6yPG43R1PWHxNq83YtaZTKi3B5HlcQYazEJqmu2eY28SbnHIHYlcY/rZkZU3U6tzyS6acb6v8gH08CPXcDSClDHoGevMYVET9j/MUfSyjdn9HT7redeoKxz+iZY9Bp57VUOsIYBtHCjYlS81dTDwhc59N9Pb2StNLdUTI8CviK9mBiAbN8ztAKhUY5m98t5RM6T9wqWyHsiCpHXv24SBtgozVXHtrbM0t3fovse1ZfjrHW0c1jUYoRguMfl1aSKQBH2RykL2VNmWeOWQn0rCblvDJLCAinD3KtoRVnZOGRXOTk4ZfUKnZXKWRx0qDGWsw5/G4/jgYE7XpSgRjM3R2sfbLNaDJrtBgzXwzKVVPMtAMTKUtotOfGmYcNCloaT99/pG70pPUHSJhirT+7RLt70DxO/I7v4WzlXCj1z9HczEozBYsMnrEyr1SEwqZrYIO1qrkMAKtVHxf95J7t+wyPabb7EtvaLB6ZmUJCZywzTMlAAAEDtJREFUaDWSZhjQTV3iWo5rGlK7Y/wT14qGTpDGWDswgRJ135qR1Xe0K5CvHFtZW/CsD80SdaWygVm9wnDAV3gOLcOjcIa6KFAXzCZGuQS9/P886+q7+/QOIsN/aHUYBgIGiiCFSAfuKprURB0gZQjOHafqo3Kef9JPlZp2QkJvAxQ29VwhXdvrZBbam2M5IEX4Icvv3ft3xJfjiI91K8/JnfMUhWYT/acUv72DGb5pL92Px+PvTos8wLVSXArgfvKRZKivEnNGFEdNJCdaunlCWGvpQXuXr9il99qGoqIdvdUKS81Gu1ePOsgi1aXPK2uc/RkvNJx1/lXV14bk2iPYUjwisvzWs/qlrA8sZf3xuP7zvHpAKxosBId2WyhRamSDXgP6OfYmzqwC223C+WVtmDub2D5OATj0nF3fzv5XuBekH3VnPZgt7SNnUZDVwwbUzznAw1nwSELKqXEhUFNlqdARr2yv4ju44RGB+Hj8198+KUAEs3hBFVWh/wlI6vudUsw+J10InT6p1uaWsfYYrGeer8KgM0DD6jMnFX2J3ZJU1M67+hRhpVfoIA87Pm54DJ2SIWwIdKWePQzmDvYOjUxDeSDeA2HpoglGJ+IuoY7l8GQcLiqkpbW7EnV+c6tu5ucZQv2mTpjNmdZIWo7ZvUlhZbMnKQ5QQA6C38k+NUgspi2PPoKH88soqC7pWkTk82tY7r9v31/bKh7meFxT2NAX9Epa2natH5DEb+Rtk7R022VSYIRFeWp53RnWmPZeLlODUp6pLTIYD1a02iNIEivge44+hSpo8H/0JzyG9jWFbPR+64VGorZKpC0E5O9WgHSbt5G3fqgyHELcEGyDa2MGtsHgTjEdMCXJadMSq7CW1+1q0wsSnWrXU20ZHgFpVbIwqev6oAJZo1EfjHLu4g8/WV8mJfi+lPa+fVGTojC7/8azui22BA2w1vU01qBlPBeOxXFBpI/xspHqg3HeJpxSu7+epkUoa3kF8HOP3mdtmFHneVaHgozfTpY0mwwL+RxpneaKn/b9IMzK4VrHMXcWItNXSmSokGfRXL8pd/rHkGeFyDnoGBq1DcJa9t45fG8NwmXkMBO3X4FoSJ2V0tIHYVDIXLJWkd4rWRpPYAbdz6yFMKxOzLBJiNbXvq5751E7zXQ0yJDDt2bOGDZKZnPH8teQFXUJOP9zBK/7eu1ojp+tsn3uBuC56dDT+wX/ksHyfgWqm8a6Q3qlqQDp1jpA+jQfPqn+myTaNk2W4yynFfiDnL6STOZQgPmZktYqLnmN6kaOlSMg5/tLtwKt+hLkw1ZuzdN+nrOuLzvK8RZeHZQWzYlTeHXBHK/ndJyR4/oBepTWhsXCon4ta7931M2jtZAV6zRjhZ8NAfiyFIohJYj0CrBWFs81B2joH8EjYlJGUs6q4hvujcBi3AV4R7b/pbF6MPqgX/3gxZxHGeIqqItHURMib3n+8oleVjtoeC2cM5nS3O+F7CgsCd2bTobIdKe4SKNfoNxXaBoqxk1q5kzASk4U2P0IFJo7p3pO8XuTRG6lE0c259I7iKT1a4mtovCHLYh88AiTJ3gI1KCEpMAPh8VPj0Kpk2JKNbYWRenMFZHzJ+YdfVWX9WmDJnv0WiHmbMOOXg6LQQzo7CIWQgKChqr93ljSQ9UOMUPzLOiJ2JXeYgisRAtMlvqVtDtqwm+wlf358f27edr3ojUNvDZ70SXVRVuL2HjGLGHXnp+6HYf9ypS5w1ZdV5XCbZcWYWUKyhrArFwlcgd0PxoLs5McRdr6X2FXu+S2DQOT2jelbihNRImyNXr/96yIXXxQ1qVu4l6SfxgSXOwugN0orFkfQQ9WUvKvhMtGZpnp6l2UhbjTDSON3Ii/tv9FtsatlrN8wNNgpgbhsQZzP9JilJjiMQfkriUgR/TAaUUpaR8hVFXUODWLw28h3Yd+3l27vVzBcTXHDSFkky1MTPiLaoNXK7fx8G9Dpe/bnPXwLQGrPIAPWZcjEVtfhdNZh4E3ELbagfsJn5hkQQ7rya2g6GCKIk6YyKMtcom4M8O9VgFFYVmD/UPqHOFJ5SlEM2/L/KoOQtyJlgbj3LXCCem95SzKzsVy1HsyzF4cdRFr/dTypVUO1lZhC9P3+trKgM76+Bnh6pO+cG66BNE3cHBfN6hh+DhaeXRDQzbrh/0FBxEI+wfjxy5hQguT5Hal3PcARz1Mh7N+Tv61r2WKjpnJ6uiipN/0ZtgQwfv8vuqyANmvh/1e8vt8DZnabSFoewETU7qObMC032dSXwNAg52sMXedcXC4t/QkOv0u0zRB/Yl3BnDd2gEWtdcClWbLVoCjluIBtvAQztc4AWdNZEqL91GUd/cUggjks/ijrYGbjFfdyNT+287XcADnLg/iqNPDtB3AKxuihyGxLrycqtHNtfJnOS3K9yU7Uuiix0CeBV9NAxMZ+sCUC3U0WFXodj8DWcfhQfPPfGTqE+/OFmLQCsLOW7P/JViPawUteV0WfLW1emewXoW2NdCimNwwjOj9oqQzNhcD3bWc0jBYmMaeS7ZZo3SBJK1yEq1YVbAW+i4XtKq2LsLcgsS25/PX8oFFKxOWyDh+EecOO2T3GJHf03sZ8lXAW5ds9atbwmSLvrYHdn2dwZIhayOn3n89DTDQWDSyh9doPkGjw51bzaksvoEcO9pIh53DixrDzjJR8vpS2U2/IMfDN2oyvVbRR60BmAbgPodz1V5D0HxvPUzFK50S+Qb+/wfzNpZdImVxx55sJDxP1gChYvj6zd4cme8Epx/8yZjCgzyvk5G/bqSc7GTf4kKFt8jti/rXpOPEbH6CSJc5V+22dLzgh6uyaOZZgpU0Rqu5jljYoJWiqBZWLGFF+D79GCzQoufXBtQA3HDewxIGYknvEnJ6UqFwVAIZzNUg84sSxYow6peNhdnWBKQwu2jRX9JbsqOShv0DExpghtT0VNXhFyi/OVINBt+PS8560zdapkhcWYjepf+XD9i+rkGkWHG0GmZoOX5bH4UzDjHdicPVhM0Skf7JNt6BBpCBeT161fJFqeiQO/3tIkokGiHrgtky6HmWjkIRU9HuVdUnI/dwcQrZM3oXuBCuvQSzmp0l/WPEWuWDgw8pizIhiJkzu7e4bW11ahGzR+sz6aay2nbeMak6wSFiOmxtTH1FyOYcHqr2HibljeFcg/pcqVTADilGmQong7AxSvlFwHCYoDp3WOsSqVYbUop2Y5Hfv0uoupNlgfrFswWE9ZLjJKjhJWlLclaSK/hbB/fp9omndjCp+Ez3Ve8lslgNUX5ezKRWmdmTloVu4tbmuJlVz26Bqn2Bo1nq8MT1+ZkbgidmV7pdfnprzncmq2Md4t51u4IPBVgbXsLtuxXSX2Mc5z6SHVVXpNiKYHcffUFAqAtz4JEtqS9hmLuwfxyfiXHlEL8qJQrWzjQj13CkHLfPgRmdj+O4OVXtU83JPRmy0sP1viaw7mT5ClUl/B5Y9rxxLejWbmITLKQYbBALZEyiDWTUEZrqV3vedk/Qqqa4yhSJVifrONuENxCTiuhx2HcArZ3XbxGCQX1rtJCCwdrrodXO3CWq6zVkW+/UB+fmLexwllENJEUlWLh67fK1hanYqVe+VMF56qTD59On0j25dkLj5T31oZkw24TkbJlr0XUwOqx14cSPBWMtZhDJUHYwtgjdJruaifw1rPryzcf9BdS/zpqpJpLIxfCo+0ECkLhTvrj8eRUWq93IrUEH2QG6SrDo24ZSQcuaCBa6r/75sfaly1ejrTQJZDKKZdUqBFplcOztNczkSGf4R89qRyD8jFLabQ36LGr57MD9iAV1uIaK0g2Nsldn6kC8ChbaOrEGDZo5HrUOtls2BHGeLF0pxOOk5TM2VonLnbaiwWY75eGWwsruGl16Pjlzlns7PDk0nCxq7dtnx6CVwEElsBplepe/jktlSFrZJdR3KQGOvv1G2n2cPvUJ3EFZY9x+2lbZyivreM/T9S+9WNhnIu4GBAXmx5FGtcQGXx3YMPbT1VwfdNzesCfG3mfTcDLNkLOGSlK8wIczLWmnamf+mB2Fzp8X7xosmkXLhx0rvI8eLl8uZF6ZRiMzwW+bQK1NIFbL91tBg7h6t+HxozzYLDPacxn3m4zpmq0w0D3Z2qpsizr2nWzDDreaQFDOSFnQlbOrDYQvYTxQ1Qyj0V50m7D8NSymWYTQvOORCt33n9j9ASJZloq/5E1seb6t5i06ZpQQviX2L/DtrS8AV1E9RWPvsXWF0BtyfNBaO0SJo1KElFngmYGXiI7RmY5IJHN0m9C2ptGqSokGSuY2avOxMBB/KK5Orqd2iR1ha82ZnqX0JYREsQrd19aKt3Mli57PkBUpdOi3Uq6Bs+iwhMLalz4mpmSChgC0rBQUSlnxKJotafujtwizi2Y2XuII6bS19sOioL2abzQmqdtXMRvnboa1ycWvUAlNerLMVqTxeinj3jaub/Iktqy1yabndg1HAnf4/Mz4iAaKFqbfOqdhdBfWHhzbY3I0mnz/C8fviKQK3CW3sRJFUC2koWE2dib6ipQVNU/kX6NVvTS0Np23Pol8F0PNOKHXpNHITFOoCzeRdB4NkG6v75csXl+/T7RVRjP2NRJUyx2J1JeNdQL355pzjrxoNkCa1MyQAjzFlHJk9qzTLKzQMR0aotdMuQvHqBIwzKbSuwZ2dxUXJfr+mKpz+bgMJidLN6hSpV9xCR+asDbUOS1oska8gGNAM9P4jDsctRYcxqQ4a+iGjca4JW2bAJWFdtV9967nxh1zacdCzQuaPW6hSPV7sBTVgBSqO9ecJr0td0rRwfgXAD8FSG/4K9hsV8r10ApfTPErtq1vsj28Jfhx5LhfrpoFyko6ITlk9rjeJHdpSujjZDOR2eQFITrXTFdDVYPMjna5veottATvHqyjBnQ1KzD9+2c3AO8ya3EYYXHThpRfly31wrq/gLQamfy9NX5mk9O1Ss5CZ0AavuDFomubtIy7IC3F59EdycaP4ralKH2prYFxU+sH2D7ZsaAX0tTnWq1wjkaQ21Jwvslce0jgpuHQOoN/+RO1w+kCSdurB6YBeb6B0fYl+OH8+qdoh9xXMtY9ybTRyLTbLItxCCfLfVg2aptDGszmJw8j6r6dDyD6AhZmKqNEOyBawwNo9Mz8F4QVRVabCNIJq84Iut2h63/mYyhfVkVvAklbvvo+I1dsiKZuu2SPOCQcXdTb88hxsowWzqJP7BhWpH0BZGXQwZTQyzRzQPmM8bZIVXquZniy9uCaicrXz5HiOYuZauoROzucInsqr2EUciTDC/HeyuZV6sJGO2Av/RksbU1VpTANT/Sl0rM9junD1ZB7L2Q2//ZCay3jhYENrAW5p0MG0TX0IE296DLZQyHYyTjulvkfhMUE7ydo8h6wKYj23QGbIu1Hnf4lKWuTs9UO1nmmGn4Q4fD7X1e9hGQYda948rlhuH5jGOY+2rxfTBBzz4y2BRCaim9beHefXQv6faG/3enQ2tlrKd7E2vB/YNYsFE3x1O7XbipdHa3g4T8lcgM3Yfvr2QAAAABJRU5ErkJggg==";

    let dateOption = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }

    const indexOfLastTrx = currentPage * trxPerPage;
    const indexOfFirstTrx = indexOfLastTrx - trxPerPage;
    
    const [loadingTracking, setLoadingTracking] = useState(false)
    const [fullDataAWB, setFullDataAWB] = useState([])
    const [showMap, setShowMap] = useState(false);

    const currentList = dataTrx.slice(indexOfFirstTrx, indexOfLastTrx)
    
    const [open, setOpen] = useState(false);

    const handlMenuClick = (name) => {
        setActiveMenu(name)
    }

    const closeAddressForm = () => (setModalAddress(false))
    const showAddressForm = () => (setModalAddress(true))

    const handleClickAccord = (e) => {
        setActiveIndex(!activeIndex)
    }

    const handleChangeIndeNumber = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === null || re.test(e.target.value)) {
            setIdenNumber(e.target.value)
        } else {
            e.target.value = ''
        }

    }

    const handleChangePhoneNumber = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === null || re.test(e.target.value)) {
            setPhone(e.target.value)
        } else {
            e.target.value = ''
        }

    }

    const closeAddressFormEdit = () => (setModalAddressEdit(false))
    const showAddressFormEdit = () => (setModalAddressEdit(true))
    const closeAddressList = () => (setModalAddressList(false))

    const showOrderDetail = () => (setOrderDetail(true))

    const hideOrderDetail = () => (setOrderDetail(false))

    const hideJoinForm = () => (setJoinForm(false))

    const showAlertJoin = () => (setAlertJoin(true))

    const closeAlertJoin = () => (setAlertJoin(false))

    const hideTermMember = () => {
        if (allowReg === "allowed") {
            setTermMember(false)
            setJoinForm(true)
        } else {
            setTermMember(false)
        }
    }

    function formatIndonesianCity(name) {
        if (/^Kota\s+/i.test(name)) {
            return name.replace(/^Kota\s+/i, '') + ' City';
        }
        if (/^Kabupaten\s+/i.test(name)) {
            return name.replace(/^Kabupaten\s+/i, '') + ' Regency';
        }
        return name;
    }

    const capitalizeWords = (str) => {
        const words = str.trim().toLowerCase().split(/\s+/);
        let result = '';

        for (let word of words) {
            const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
            if ((result + capitalizedWord + ' ').length > 26) break;
            result += capitalizedWord + ' ';
        }

        return result.trim();
        // return str
        //     .toLowerCase()
        //     .split(' ')
        //     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        //     .join(' ');
    };

    const groupByWarehouse = (details) => {
        const grouped = details.reduce((acc, det) => {
            const key = det.id_warehouse || 'UNKNOWN';
            if (!acc[key]) acc[key] = [];
            acc[key].push(det);
            return acc;
        }, {});

        const sorted = Object.entries(grouped).sort(([a], [b]) => {
            if (a === 'WH0006') return -1;
            if (b === 'WH0006') return 1;
            return a.localeCompare(b);
        });

        return Object.fromEntries(sorted);
    };

    useEffect(() => {
        getWarehouseDetail()
    }, []);

    useEffect(() => {
        // console.log(selectedOrderId)
        getShippingDetail(selectedOrderId)
    }, [selectedOrderId]);

    const getShippingDetail = async (orderId) => {
        // let isValid = tempOrderId !== orderId
        // console.log(isValid)
        // if(isValid) {
        setShippingDetail(null)
        setTempOrderId(orderId)
        setShippingDetailLoader(true)
        const param = new URLSearchParams()
        param.append('id_order', orderId)
        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/order.php/?index=20`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state == 200) {
                    let data = response.data.data
                    setShippingDetail(data)
                    //console.log(data)
                }
                setShippingDetailLoader(false)
            })
            .catch((error) => console.log(/*error.response.state*/))
        setShippingDetailLoader(false)
        // }
    }

    const getWarehouseDetail = async () => {
        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/cart.php/?index=22`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token

            },
        })
            .then((response) => {
                if (response.data.state == 200) {
                    let data = response.data.data
                    setWarehouseDetailData(data)
                }
                setWarehouseDetailLoader(false)
            })
            .catch((error) => console.log(/*error.response.state*/))
        setWarehouseDetailLoader(false)
    }

    const GroupedByWarehouse = ({ item }) => {
        const grouped = groupByWarehouse(item.product_details);
        const [activeIndex, setActiveIndex] = useState(-1);

        const handleClick = (index) => {
            const newIndex = activeIndex === index ? -1 : index;
            setActiveIndex(newIndex);
        };

        return (
            <Accordion className="mb-3" fluid styled>
                {Object.entries(grouped).map(([warehouseId, products], idx) => (
                    <div key={warehouseId}>
                        <Accordion.Title
                            active={activeIndex === idx}
                            index={idx}
                            onClick={() => handleClick(idx)}
                        >
                            <Icon name='dropdown' />
                            {!warehouseDetailLoader ? (
                                warehouseDetailData
                                    ? `Warehouse: ${capitalizeWords((warehouseDetailData[warehouseId]?.name) ? (warehouseDetailData[warehouseId]?.name) : 'Unknown Warehouse')}, ${formatIndonesianCity(capitalizeWords(warehouseDetailData[warehouseId]?.city ? warehouseDetailData[warehouseId]?.city : 'Unknown City'))}` || 'Unknown Warehouse'
                                    : 'Unknown Warehouse'
                            ) : (
                                <span className='me-4'>
                                    <Placeholder>&nbsp;</Placeholder>
                                </span>
                            )}
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === idx}>
                            <Row>
                                <Col md={9}>
                                    {products.map((det, i) => (
                                        <Stack direction="horizontal" gap={3} key={i} className="mb-3">
                                            <Image
                                                className="border"
                                                src={det.image_order || "https://via.placeholder.com/500x400.png"}
                                                width={75}
                                                rounded
                                            />
                                            <Stack direction="vertical" gap={0}>
                                                <div>{det.id_product}</div>
                                                <div
                                                    className="fw-bold"
                                                    style={{ color: "#ff5733", cursor: 'pointer' }}
                                                    onClick={() => navigate(`/product/${det.id_product}`)}
                                                >
                                                    {det.product_name || det.name_order}
                                                </div>
                                                <div>
                                                    <span className="me-2">{global.IDR.format(det.total_price_order)}</span>
                                                    <div>
                                                        <span className="me-4">Size: {det.size_order}</span>
                                                        <span className="me-4">Qty: {det.qty_order}</span>
                                                    </div>
                                                </div>
                                            </Stack>
                                        </Stack>
                                    ))}
                                </Col>
                                <Col md={3}>
                                    <div className="d-flex justify-content-end float-lg-end">
                                        <TrxAction state={item.order_state} item={item} warehouseId={warehouseId} />
                                    </div>
                                </Col>
                            </Row>
                        </Accordion.Content>
                    </div>
                ))}
            </Accordion>
        );
    };



    const trackingJNE = async (awb, id_order) => {
        setLoadingTracking(true)

        //console.log(`awb: ${awb}`)
        //console.log(`id_order: ${id_order}`)

        const param = new URLSearchParams()
        param.append('awb', awb)
        //param.append('awb', '160560008686424') //sandboxsetTrackJneDatarac

        const param_register = new URLSearchParams()
        param_register.append('AWB_NUMBER', awb)
        param_register.append('ORDER_ID', id_order)

        //Temporary Register Airwaybill untuk ownership tracking via API
        const registerRes = await axios.post(
            `https://dev.javafootwear.com/api_nba/controler/courier.php/?index=9`,
            param_register,
            {
                headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: token
                }
            }
        )
        //console.log("register:", registerRes)


        await axios({
            method: "POST",
            url: `https://dev.javafootwear.com/api_nba/controler/courier.php/?index=4`,
            //url: `https://apiv2.jne.co.id:10205/tracing/api/list/cnoteretails/cnote/`+ awb,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
        .then(res => {
            setLoadingTracking(false)
            setOpenTrk(true)
            setAwbResponse(res.data.error)
            if (res.data.status != false && typeof res.data == 'object') {
                setTrackJneData(res.data)
                setHistory(res.data.history.sort((a, b) => a.date - b.date).reverse())
            } else if (typeof res.data !== 'object') {
                Toast.fire({
                    icon: "warning",
                    text: "Resi number can't be tracked yet, maybe there is an error on courier response",
                    position: "center"
                })
            }
        })
    }

     //Tracking PAXEL 
     /*
    const getPaxelStatusLabel = (code) => {
        return PAXEL_STATUS_MAP[code] || code
    }

    const trackingPaxelMock = () => {
        const logs = [...paxelMock.data.logs].reverse()

        const formattedHistory = logs.map(item => ({
            date: item.created_datetime,
            desc: `${getPaxelStatusLabel(item.status)} - ${item.name}`
        }))

        setHistory(formattedHistory)
        setOpenTrk(true)
    }
    */
    
     //Tracking PAXEL 
    const getPaxelStatusLabel = (code) => {
        return PAXEL_STATUS_MAP[code] || code
    }

    
    const trackingPaxel = async (awb) => {
    //const trackingPaxelMock = () => {
        setLoadingTracking(true)
        
        //console.log(`awb: ${awb}`)

        const param = new URLSearchParams()
        param.append('awb', awb)

        const dataAWB = await axios.post(
            `https://dev.javafootwear.com/api_nba/controler/courier.php/?index=10`,
            param,
            {
                headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: token
                }
            }
        )
        //console.log("Tracking Paxel : ", dataAWB)
        const rawData = dataAWB.data.data
        setFullDataAWB(dataAWB.data.data)

        let logs = rawData.logs || []

        if (logs.length === 0) {
            logs = [
                {
                    status: rawData.latest_status,
                    created_datetime: rawData.created_datetime,
                    name: rawData.airwaybill_code,
                    note: "note"
                }
            ]
        }

        const formattedHistory = logs.map(item => ({
            date: item.created_datetime,
            desc: `${getPaxelStatusLabel(item.status)}`,
            note: `${getPaxelStatusLabel(item.note)}`
        }))

        //setHistory(formattedHistory)
        setHistory(formattedHistory.sort((a, b) => a.date - b.date).reverse())
        setOpenTrk(true)
        setLoadingTracking(false)
    }

    const TrxAction = ({ state, item, warehouseId }) => {
        const filteredDetails = warehouseId !== null
            ? item.product_details.filter(det => det.id_warehouse === warehouseId)
            : item.product_details;
        const filteredItem = { ...item, product_details: filteredDetails, id_warehouse: warehouseId };
        switch (state) {
            case "PAYMENT PENDING":
                return (
                    <Col md={12} className="d-flex justify-content-start align-self-end">
                        <Button
                            content="Continue to Payment"
                            basic
                            size="small"
                            onClick={() => navigate('/cart/checkout/paymentSnap')}
                        />
                    </Col>
                )
            case "SETTLEMENT":
                return (
                    <Col md={12} className="d-flex justify-content-start align-self-end">
                        <Button
                            content="View Order Detail"
                            basic
                            color="orange"
                            size="small"
                            onClick={() => {
                                showOrderDetail()
                                // setSelectedOrder(item)
                                setSelectedOrder(filteredItem)
                                //console.log(filteredItem)
                                setSelectedOrderId(filteredItem.id_order)
                            }}
                        />
                    </Col>
                )
            case "CAPTURE":
                return (
                    <Col md={12} className="d-flex justify-content-start align-self-end">
                        <Button
                            content="View Order Detail"
                            basic
                            size="small"
                            onClick={() => {
                                showOrderDetail()
                                // setSelectedOrder(item)
                                setSelectedOrder(filteredItem)
                                setSelectedOrderId(filteredItem.id_order)
                            }}
                        />
                    </Col>
                )
            case "IN DELIVERY":
                return (
                    <Col md={12} className="d-flex justify-content-start align-self-end">
                        <Button
                            content="View Order Detail"
                            basic
                            color="orange"
                            size="small"
                            onClick={() => {
                                showOrderDetail()
                                // setSelectedOrder(item)
                                setSelectedOrder(filteredItem)
                                setSelectedOrderId(filteredItem.id_order)
                                // getShippingDetail(filteredItem.id_order)
                                setActiveIndex(false)
                                setOpenTrk(false)
                                setAwbNumber(item.no_resi)
                            }}
                        />
                    </Col>
                )
            case "PICK UP COMPLETED":
                return (
                    <Col md={12} className="d-flex justify-content-start align-self-end">
                        <Button
                            content="View Order Detail"
                            basic
                            color="orange"
                            size="small"
                            onClick={() => {
                                showOrderDetail()
                                // setSelectedOrder(item)
                                setSelectedOrder(filteredItem)
                                setSelectedOrderId(filteredItem.id_order)
                                // getShippingDetail(filteredItem.id_order)
                                setActiveIndex(false)
                                setOpenTrk(false)
                                setAwbNumber(item.no_resi)
                            }}
                        />
                    </Col>
                )
            case "ARRIVE AT DESTINATION":
                return (
                    <Col md={12} className="d-flex justify-content-start align-self-end">
                        <Button
                            content="View Order Detail"
                            basic
                            size="small"
                            onClick={() => {
                                showOrderDetail()
                                setSelectedOrder(item)
                                setSelectedOrderId(filteredItem.id_order)
                                setActiveIndex(false)
                                setOpenTrk(false)
                                setAwbNumber(item.no_resi)
                            }}
                        />
                    </Col>
                )
            case "WAITING PAYMENT":
                return (
                    <Col md={12} className="d-flex justify-content-start align-self-end">
                        <Button
                            content="Continue to Order"
                            basic
                            size="small"
                            onClick={() => navigate("/cart/checkout")}
                        />
                    </Col>
                )
            default: return (<></>)
        }
    }

    const SpinerBorder = () => {
        return (<><Divider horizontal>Or wait for it to load</Divider><Spinner animation="border" /></>);
    }


    const handleChangePage = (e, { activePage }) => (setCurrentPage(activePage))

    const calcCoret = (data) => {
        if (data.fs_on === true) {
            return data.price
        } else if (data.isDiscounted == '1') {
            return data.price
        }
    }

    const Transaction = ({ data }) => {
        if (data.length === 0) {
            return (
                <Segment>
                    <h3><Icon name="shopping basket" className="me-2" />Transaction</h3>
                    <div>You haven't made any transactions, let's buy some products now</div>
                    {isLoadTrx && (
                        <div className="text-center"><SpinerBorder /></div>
                    )}
                </Segment>
            )
        } else {
            return (
                <Segment>
                    <h3><Icon name="shopping basket" className="me-2" />Transaction</h3>
                    {
                        data.map((item, idx) => {
                            const hasWarehouse = item.product_details.every(det => det.hasOwnProperty('id_warehouse') && det.id_warehouse);
                            return (
                                <div className={item.order_state.toLowerCase() == 'settlement' || item.order_state.toLowerCase() == 'in delivery' || item.order_state.toLowerCase() == 'pick up completed' ? 'callout-active' : 'callout'} key={idx}>
                                    <Row>
                                        <Col xs={12} sm={12} md={12}>
                                            <Row className="mb-3">
                                                <div className="d-flex justify-content-between align-items-start w-100 flex-wrap">
                                                    <div className="mb-2 col-lg-6 col-sm-12">
                                                        <Stack direction="horizontal" gap={2}>
                                                            <div><Icon name="shop" /></div>
                                                            <div className="fw-bold">{item.id_order}</div>
                                                            <div>{new Date(item.order_date).toLocaleDateString('en-US', formatLongDate)}</div>
                                                        </Stack>
                                                    </div>

                                                    {(hasWarehouse && windowWidth > 1200) && (
                                                        <div className="d-none d-lg-flex col-lg-6 justify-content-end">
                                                            <Stack direction="horizontal" gap={2}>
                                                                <div>
                                                                    <Popup
                                                                        trigger={
                                                                            <Label
                                                                                size="mini"
                                                                                color={
                                                                                    item.order_state.toLowerCase() === 'settlement' ||
                                                                                        item.order_state.toLowerCase() === 'in delivery' ||
                                                                                            item.order_state.toLowerCase() === 'pick up completed'    
                                                                                            ? 'orange'
                                                                                            : 'grey'
                                                                                }
                                                                            >
                                                                                {item.order_state}
                                                                            </Label>
                                                                        }
                                                                        content="Your order status"
                                                                    />
                                                                </div>
                                                                <div>Total Order</div>
                                                                <div className="fw-bold">{global.IDR.format(item.total_payment)}</div>
                                                            </Stack>
                                                        </div>
                                                    )}
                                                </div>
                                            </Row>
                                            {
                                                !hasWarehouse && item.product_details.map((det, i) => {
                                                    return (
                                                        <Stack direction="horizontal" gap={3} key={i} className="mb-3">
                                                            <Image
                                                                className="border"
                                                                src={det.image_order ? det.image_order : "https://via.placeholder.com/500x400.png"}
                                                                width={75}
                                                                rounded
                                                            />
                                                            <Stack direction="vertical" gap={0}>
                                                                {/* <div className="fw-bold">{det.product_name || det.name_order + ' (Unavailable)'}</div> */}
                                                                <div>{det.id_product}</div>
                                                                <div className="fw-bold" style={{ color: "#ff5733", cursor: 'pointer' }} onClick={() => navigate(`/product/${det.id_product}`)}>{det.product_name || det.name_order}</div>
                                                                <div>
                                                                    <span className="me-2">{global.IDR.format(det.total_price_order)}</span>
                                                                    {/* <span className="me-4 text-muted"><s>{calcCoret(det)}</s></span> */}
                                                                    <div>
                                                                        <span className="me-4">Size: {det.size_order}</span>
                                                                        <span className="me-4">Qty: {det.qty_order}</span>
                                                                    </div>
                                                                </div>
                                                            </Stack>
                                                        </Stack>
                                                    )
                                                })
                                            }
                                            {
                                                hasWarehouse && <GroupedByWarehouse item={item} />
                                            }
                                            <div>
                                                {
                                                    item.lottery_number &&
                                                    <Popup
                                                        trigger={<Label color="orange"><Icon name="sticky note outline" />{item.lottery_number}</Label>}
                                                        content="You have received a lottery code from this transaction"
                                                    />

                                                }
                                            </div>
                                        </Col>
                                        {
                                            (!hasWarehouse || windowWidth <= 1200) && (
                                                <Col md={3} className="align-self-center">
                                                    <Row style={{ height: '15vh' }}>
                                                        <Col md={12} className="">
                                                            <Popup
                                                                trigger={<Label size="mini" color={item.order_state.toLowerCase() == 'settlement' || item.order_state.toLowerCase() == 'in delivery' || item.order_state.toLowerCase() == 'pick up completed' ? 'orange' : 'grey'}>{item.order_state}</Label>}
                                                                content="Your order status"
                                                            />
                                                        </Col>
                                                        <Col md={12} className="justify-content-start align-self-center">
                                                            <div className="me-3">Total Order</div>
                                                            <div className="fw-bold">{global.IDR.format(item.total_payment)}</div>
                                                        </Col>
                                                        {
                                                            !hasWarehouse && <TrxAction state={item.order_state} item={item} warehouseId={null} />
                                                        }
                                                    </Row>
                                                </Col>
                                            )}
                                    </Row>
                                </div>
                            )
                        }
                        )
                    }

                    <Row className="d-flex justify-content-end ">
                        <Col xs={12} md={12} lg={8} className="text-end ">
                            <Pagination
                                firstItem={windowWidth < 600 ? false : true}
                                lastItem={windowWidth < 600 ? false : true}
                                boundaryRange={windowWidth < 600 ? 0 : 1}
                                activePage={currentPage}
                                totalPages={Math.ceil(dataTrx.length / trxPerPage)}
                                onPageChange={handleChangePage}
                            />
                        </Col>
                    </Row>
                </Segment>

            )
        }
    }


    const handleAddPhoto = (e) => {
        let param = new FormData();

        param.append("image", e[0])
        param.append("id_customer", idCustomer)

        axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/customer.php/?index=9`,
            headers: { 'Content-Type': 'text/plain', 'Authorization': token },
            data: param
        })
            .then(res => {
                if (res.data.state === 200) {
                    setImageProf(res.data.image)
                    alert(res.data.message)
                } else {
                    alert(res.data.message)
                }
            })
    }

    const ProfileContent = () => (
        <Segment>
            <h3><Icon name="user outline" className="me-2" />Profile</h3>
            <Row>
                <Col md={4}>
                    <Image src={profile.avatar ? profile.avatar : DEFAULT_PROFIL_IMAGE} fluid className="mb-3 rounded" />
                    <Frm.Input
                        type="file"
                        basic
                        fluid
                        icon="image"
                        className="mb-3"
                        onChange={(e) => handleAddPhoto(e.target.files)}
                    />
                </Col>
                <Col md={8}>
                    <h4>Personal Data</h4>
                    <div className="mb-3">
                        <List>
                            <List.Item>
                                <Row>
                                    <Col md={4}>Name</Col>
                                    <Col md={8}><div className="fw-bold text-capitalize">{profile.first_name} {profile.last_name}</div></Col>
                                </Row>
                            </List.Item>
                            <List.Item>
                                <Row>
                                    <Col md={4}>Date of Birth</Col>
                                    <Col md={8}><div className="fw-bold">{new Date(profile.dob).toLocaleDateString('en-US', formatLongDate)}</div></Col>
                                </Row>
                            </List.Item>
                            <List.Item>
                                <Row>
                                    <Col md={4}>Gender</Col>
                                    <Col md={8}><div className="fw-bold">{(profile.gender === "M" ? "Male" : "Female")}</div></Col>
                                </Row>
                            </List.Item>
                        </List>
                    </div>
                    <h4>Contact</h4>
                    <div>
                        <List>
                            <List.Item>
                                <Row>
                                    <Col md={4}>Email</Col>
                                    <Col md={8}>
                                        <span className="fw-bold me-3">{profile.email}</span>
                                        <span className="me-3">{(profile.verified == "1") ? <Label size="tiny" color="orange">Verified</Label> : <></>}</span>
                                    </Col>
                                </Row>
                            </List.Item>
                            <List.Item>
                                <Row>
                                    <Col md={4}>Phone Number</Col>
                                    <Col md={8}>
                                        <div className="fw-bold">
                                            {(profile.address && profile.address.length > 0 && profile.address[0].celular_number) ? 
                                                profile.address[0].celular_number 
                                                : 
                                                <div>
                                                    <p className="warning-pulse-color" style={{fontSize: '0.95rem', fontWeight: '600'}}>
                                                        <span style={{marginRight: "10px"}} >Please Add Phone Number ! </span>
                                                        <Popup
                                                            open={open}
                                                            trigger={
                                                                <span
                                                                    style={{ marginLeft: "10px", cursor: "pointer" }}
                                                                    onClick={() => setOpen(true)}
                                                                >
                                                                    <Icon name="warning circle" style={{color: "#f2711c"}} />
                                                                </span>
                                                            }
                                                            position={
                                                                windowWidth < 700
                                                                    ? "bottom center"
                                                                    : windowWidth < 1250
                                                                    ? "bottom left"
                                                                    : "bottom center"
                                                            }
                                                            style={{ transform: "translateY(10px)", zIndex: 50 }}
                                                        >
                                                            <Popup.Content
                                                                className="text-center"
                                                                style={{
                                                                    width: 350,
                                                                    position: "relative",
                                                                }}
                                                            >
                                                                <Icon
                                                                    name="close"
                                                                    link
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        right: 0,
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => setOpen(false)}
                                                                />

                                                                <div style={{ paddingRight: 20 }}>
                                                                    Please add or update your phone number in your default shipping address.
                                                                </div>

                                                                <Button
                                                                    size="small"
                                                                    content="Update Shipping Address"
                                                                    style={{
                                                                        marginTop: "1em",
                                                                        background: "#f2711c",
                                                                        color: "#fff",
                                                                    }}
                                                                    onClick={() => {
                                                                        setOpen(false);
                                                                        handlMenuClick("address");
                                                                    }}
                                                                />
                                                            </Popup.Content>
                                                        </Popup>
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </Col>


                                    
                                    {/* 
                                    
                                            <Col className="text-center" style={{ paddingTop: '1rem' }}>
                                                <Message info warning>
                                                <Icon name='warning circle' />
                                                <Message.Header>Phone Number of Default Shipping Address is Required.</Message.Header>
                                                <Message.Content>
                                                    <p>Please add or update your phone number in your default shipping address.</p>
                                                    <Button 
                                                        primary
                                                        style={{
                                                            background: '#9a6700',
                                                            color: '#fff'
                                                        }}
                                                        onClick={() => handlMenuClick("address")}
                                                    >
                                                    Update Shipping Address
                                                    </Button>
                                                </Message.Content>
                                                </Message>
                                            </Col>
                                    
                                    {(  profile.address &&
                                        profile.address.length > 0 &&
                                        !profile.address[0].celular_number) && 
                                        (
                                            <Col style={{ paddingTop: '1rem' }}>
                                                <div
                                                    className="text-center rounded p-3 mb-4 mt-2"
                                                    style={{
                                                        background: '#fffaf3',
                                                        border: '1px solid #573a08'
                                                    }}
                                                >
                                                    <div>
                                                        <Icon name='warning circle' size='huge' style={{color: '#573a08', marginBottom: '10px'}}/>
                                                    </div>
                                                    <div
                                                        className="fw-bold mb-2"
                                                        style={{ color: '#573a08' }}
                                                    >
                                                        PHONE NUMBER REQUIRED
                                                    </div>

                                                    <div
                                                        className="mb-3"
                                                        style={{
                                                            color: '#756000',
                                                            fontSize: '0.95rem'
                                                        }}
                                                    >
                                                        Please add or update your phone number in your default shipping address.
                                                    </div>

                                                    <Button
                                                        size="small"
                                                        content="Update Shipping Address"
                                                        icon="edit"
                                                        labelPosition="left"
                                                        style={{
                                                            background: '#573a08',
                                                            color: '#fff'
                                                        }}
                                                        onClick={() => handlMenuClick("address")}
                                                    />
                                                </div>
                                            </Col>
                                        )
                                    }
                                        
                                    */}

                                </Row>
                            </List.Item>
                        </List>
                    </div>
                </Col>
            </Row>
        </Segment>
    )

    const updateList = (idProduct) => {
        setProductData(productData.filter(i => i.id_product !== idProduct))
    }

    const populateWishData = (data) => {
        return (
            <Segment>
                <h3><Icon name="heart outline" className="me-2" />Wishlist</h3>
                <Row>
                    {
                        data.map((item, i) => {
                            return (
                                <ProductCard data={item} option='wishlist' key={i} updateList={updateList} />
                            )
                        })
                    }
                </Row>
            </Segment>
        )
    }

    const Wishlist = ({ data }) => {
        if (data.length > 0) {
            return (
                <Segment>
                    <h3><Icon name="heart outline" className="me-2" />Wishlist</h3>
                    <Row>
                        {
                            data.map((item, i) => {
                                return (
                                    <ProductCard data={item} option='wishlist' getWish={getWish} key={i} updateList={updateList} 
                                    isWish={true}/>
                                )
                            })
                        }
                    </Row>
                </Segment>
            )
        } else {
            return (
                <Segment>
                    <h3><Icon name="heart outline" className="me-2" />Wishlist</h3>
                    <p>No wishlisted product</p>
                </Segment>
            )
        }

    }

    const handleClickJoin = (e, point) => {
        e.preventDefault()

        const param = new URLSearchParams();
        param.append("phone", phone)
        param.append("identity", iden)
        param.append("identity_number", idenNumber)
        param.append("city", city)
        param.append("address", addr)
        param.append("isCorrectInput", checkCorrect)
        param.append("isAgreeTerm", checkTerm)
        param.append('id_customer', cart.customer.id_customer && idCustomer)
        param.append('first_point', point)

        axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/member.php/?index=1`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then(response => {
                if (response.data.state === 200) {
                    alert("Your member registration is successful")
                    setJoinForm(false)
                    setAllowReg("disalowed")
                    updateNotif(cart.customer.id_customer && idCustomer)
                }
            })
    }

    // const Membership = ({ profile, address }) => { 
    //     if (allowReg === "allowed") {
    //         return (
    //             <Segment>
    //                 <h3><Icon name="address card outline" className="me-2"/>Membership</h3>
    //                 <Row>
    //                     <Col>
    //                         <Button content="Join Membership" onClick={() => setJoinForm(true)} />
    //                     </Col>
    //                 </Row>

    //                 {/* <Modal show={termMember} backdrop='static' keyboard={false} onHide={hideTermMember} size="md">
    //                     <Modal.Header closeButton><span className="fs-5">Term of Membership</span></Modal.Header>
    //                     <Modal.Body>
    //                         <TermMember />
    //                     </Modal.Body>
    //                 </Modal> */}
    //             </Segment>
    //         )
    //     } else if (allowReg === "ismember") {
    //         let dobToDate = new Date(member.dob)

    //         return (
    //             <Segment>
    //                 <h3><Icon name="address card outline" className="me-2"/>Membership</h3>
    //                 <Row>
    //                     <Col md={12} className="mb-4">
    //                         <Row>
    //                             <Col md={12} className="fw-bold mb-2">Point Info</Col>
    //                             <Col md={4} className="">
    //                                 <div>Current Point</div>
    //                                 <div>Point used</div>
    //                             </Col>
    //                             <Col md={8} className="">
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{global.Point.format(member.point_state)} Point</div>
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{global.Point.format(member.point_used)} Point</div>
    //                             </Col>
    //                         </Row>
    //                     </Col>
    //                     <Col md={12} className="mb-4">
    //                         <Row>
    //                             <Col md={12}>
    //                                 <div className="fw-bold mb-2">Member Profile</div>
    //                             </Col>
    //                             <Col md={4}>
    //                                 <div>Id Member</div>
    //                                 <div>Identity</div>
    //                                 <div>Name</div>
    //                                 <div>Gender</div>
    //                                 <div>Email / Username</div>
    //                                 <div>DoB</div>
    //                                 {/* <div>Agree with membership term</div> */}
    //                             </Col>
    //                             <Col md={8}>
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{member.id_member}</div>
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{member.identity}&nbsp;{member.identity_number}</div>
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{member.first_name}&nbsp;{member.last_name}</div>
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{(member.gender === 'M') ? 'Male' : 'Female'}</div>
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{member.email}</div>
    //                                 <div className="fw-bold">: &nbsp;&nbsp;{dobToDate.toLocaleDateString('en-US', dateOption)}</div>
    //                                 {/* <div className="fw-bold">: &nbsp;&nbsp;{member.isAgreeTerm == 'Y' ? 'Yes' : 'No'}</div> */}

    //                             </Col>
    //                         </Row>
    //                     </Col>
    //                 </Row>
    //             </Segment>
    //         )
    //     } else if (allowReg === "disalowed") {
    //         return (
    //             <Segment>
    //                 <h3><Icon name="address card outline" className="me-2"/>Membership</h3>
    //                 <Row>
    //                     <Col md={12} className="mb-3">
    //                         <Button content="Join Membership" onClick={() => showAlertJoin()} />
    //                     </Col>
    //                 </Row>

    //             </Segment>
    //         )
    //     }
    // }

    // const getOrderAddress = async (idOrder) => {
    //     const param = new URLSearchParams
    //     param.append('id_order', idOrder)

    //     await axios({
    //         method: "POST",
    //         url: `${global.SRV}api_hoops/controler/order.php/?index=10`,
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded',
    //         },
    //         data: param
    //     })
    //         .then(response => {
    //             if (response.data.state === 200) {
    //                 setOrderAddress(response.data.data)
    //             }
    //         })
    // }


    const setDefaultAddress = (idAddress, status) => {
        const param = new URLSearchParams();

        param.append('id_address', idAddress);
        param.append('status', status)
        param.append('id_customer', idCustomer)

        axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/customer.php/?index=4`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state === 200) {
                    getCustomerAddress(idCustomer)
                    // if (cart.customer.address !== null) {
                    //     if (!orderAddress) {
                    //         setUserAddress(cart.customer.address)
                    //     } else {
                    //         setUserAddress(orderAddress)
                    //     }
                    // } else if (cart.customer.address === null) {
                    //     if (!orderAddress) {
                    //         setUserAddress(response.data.data.filter(i => i.isDefault == 1)[0])
                    //     } else {
                    //         setUserAddress(orderAddress)
                    //     }
                    // }
                    setHideWarn(false)
                }
            })
    }


    const Address = (idCust) => {
        return (
            <Segment>
                <h3><Icon name="map marker alternate" />Shipping Address</h3>
                <Row>
                    <Col>
                        <Message
                            onDismiss={() => setHideWarn(true)}
                            size="small"
                            hidden={hideWarn}
                            success
                            icon='check circle outline'
                            header='Update address success.'
                            content='Make sure the address on your order page is correct, because this will not directly change the address on the order page.'
                        />
                    </Col>
                </Row>
                
                {(  profile.address &&
                    profile.address.length > 0 &&
                    !profile.address[0].celular_number) && 
                    (
                        <Row style={{paddingTop: "1rem"}}>
                            <Col>
                                <Message
                                    size="small"
                                    warning
                                    icon='warning circle'
                                    header='Phone Number of Default Shipping Address is Required.'
                                    content='Please add or update your phone number in your default shipping address.'
                                />
                            </Col>
                        </Row>
                    )
                }

                {addressList.length > 0 ?
                    addressList.map((item, i) => (
                        <section className={item.isDefault === '1' ? "callout-active" : "callout"} key={i}>
                            <Row className="d-flex justify-content-start align-items-middle">
                                <Col lg={10} md={10} sm={10}>
                                    <span className="fw-bold me-3">{item.address_label}</span>
                                    <span>{(item.isDefault == 1) ? <Label>Default</Label> : <></>}</span>
                                    <div>{item.recipient_name}</div>
                                    
                                    { item.celular_number ? 
                                        <div>
                                            {item.celular_number }
                                        </div>
                                        : 
                                        <div className="warning-pulse-color" style={{fontSize: '0.95rem', fontWeight: '600'}}>
                                            Please Add Phone Number !
                                        </div>
                                    }
                                    <div><span>{item.address_detail}</span> <span>{item.address_detail_dua}</span></div>
                                    <div>{item.destination}</div>
                                    <Button.Group basic className="mt-3" color="orange">
                                        <Button
                                            content="Edit Address"
                                            onClick={() => {
                                                setSelectedAddressEdit(item)
                                                if (setSelectedAddressEdit !== null) {
                                                    showAddressFormEdit();
                                                    closeAddressList()
                                                }
                                            }}
                                        />
                                        {(item.isDefault == 1) ? <></> :
                                            <Button
                                                content="Make Default"
                                                onClick={() => setDefaultAddress(item.id_address, (item.isDefault == 0) ? 1 : 0)} />}
                                    </Button.Group>
                                </Col>
                                {/* <Col lg={2} md={2} sm={2} className="d-flex justify-content-end align-self-center">
                                    {(item.id_address === selectedAddress.id_address) ?
                                        <FontAwesomeIcon className="text-muted fs-5" icon={faCheck} /> :
                                        <Button content="Select"
                                            onClick={() => {
                                                setUsedAddress(addressList, item.id_address)
                                                closeAddressList()
                                                updateOrderAddress(cart.summary.order_id, item.id_address)
                                            }} />}
                                </Col> */}
                            </Row>
                        </section>
                    ))
                    : <div className="text-center mb-4"><Image src={noDataImg} width={60} height={60} /></div>
                }
                <Row>
                    <Col>
                        {
                            addressList?.length <= 1 ?
                                <Button
                                    color="orange"
                                    icon="plus"
                                    content="Add New Address"
                                    fluid
                                    basic
                                    onClick={() => {
                                        showAddressForm()
                                        // closeAddressList()
                                    }} />
                                :
                                <div className="border p-2 text-center small rounded"><i>Can't add more address, limited {addressState.limit} addresses per customer</i></div>
                        }
                    </Col>
                </Row>
            </Segment>
        )
    }

    const RenderedContent = () => {
        switch (activeMenu) {
            case "transaction": return <Transaction data={currentList} />; break;
            case "profile": return <ProfileContent />; break;
            case "wishlist": return <Wishlist data={wishData} />; break;
            // case "membership": return <Membership profile={profile} address={cart.customer.address} />; break;
            case "address": return <Address idCust={idCustomer} />; break;
            default: if (showMenu) { if (showMenu === "trxActive") { return <Transaction data={dataTrx} /> } } else { return <ProfileContent /> }; break;
        }
    }

    const getProductData = async (id_customer, id_category, id_product) => {
        const param = new URLSearchParams()
        param.append('id_category', id_category)
        param.append('id_customer', id_customer)

        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_ERP_URL}api_web/controler/product${global.APPSUFFIX}.php?index=1`,
            // url: "https://hoopsindonesia.co.id/api_hoops/controler/product.php?index=1",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                const data = response.data.data.filter(i => i.id_product === id_product)[0]
                let index = productData.findIndex(i => i.id_product == data.id_product)
                index === -1 && setProductData([...productData, data])
            })
    }


    const filterCity = (inputValue) => {
        // const compressedData = localStorage.getItem('_destination');
        // const decompressedData = JSON.parse(LZString.decompressFromBase64(compressedData));

        return optionCity.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        )
    }

    const promiseOptionsCity = (inputValue) => (
        new Promise((resolve) => {
            setTimeout(() => {
                resolve(filterCity(inputValue));
            }, 1000)
        })
    );

    const getZipCode = (destination) => {
        const postalCode = allCity.filter((i) => i.id_destination === destination).map(i => i.zip_code)
        setZipCode(postalCode[0])
    }

    const getCustomerAddress = async (idCustomer) => {
        const param = new URLSearchParams()
        param.append('id_customer', idCustomer)

        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/customer.php/?index=3`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                if (response.data.state === 200) {
                    setAddressList(response.data.data)
                }
            })
    }

    useEffect(() => {

        getCustomerAddress(idCustomer)

    }, [idCustomer])

    useEffect(() => {
        const customerTrx = async (idCust) => {
            const param = new URLSearchParams()
            param.append('id_customer', idCust)
            setIsLoadTrx(true)
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/order.php/?index=16`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token,
                },
                data: param
            })
            .then(response => {
                if (response.data.state == 200) {
                    let data = response.data.data;
                    setDataTrx(data)
                }
            })
            .finally(() => {
                setIsLoadTrx(false)
            })
        }

        if (idCustomer) {
            customerTrx(idCustomer)
            getWish(idCustomer)
        }

    }, [idCustomer])

    const getWish = (id_customer) => {
        const param = new URLSearchParams()

        param.append('id_customer', id_customer)
        //if (wishData.length == 0) {
            axios({
                method: "POST",
                url: `${process.env.REACT_APP_ERP_URL}api_web/controler/product${global.APPSUFFIX}.php?index=5`,
                // url: 'https://hoopsindonesia.co.id/api_hoops/controler/product.php?index=5',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    if (response.data.state === 200) {
                        setWishData(response.data.data)
                    } else {
                        return (<>Error..</>)
                    }
                })
        //}

    }

    useEffect(() => {
        const profile = async (idCust) => {
            const param = new URLSearchParams()
            param.append('id_customer', idCust)

            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/customer.php/?index=8`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
            .then(response => {
                if (response.data.state == 200) {
                    setProfile(response.data.data)
                    if (profile.address && profile.address.length > 0 && profile.address[0].celular_number){
                        setOpen(false)
                    } else {
                        setOpen(true)
                    }
                }
            })
        }

        if (idCustomer) {
            profile(idCustomer)
        }

        setPhone(cart.customer.address ? cart.customer.address.celular_number : '')
        setIden('KTP')
    }, [idCustomer, cart, addressList, wishData])

    useEffect(() => {
        // const generateCityOption = async () => {
        //     let option = []
        //     await axios({
        //         method: 'GET',
        //         url: `${global.SRV}api_hoops/controler/courier.php/?index=1`,
        //         headers: {
        //             'Content-Type': 'application/x-www-form-urlencoded',
        //             'Authorization': token
        //         }
        //     })
        //         .then((response) => {
        //             if (response.data.length > 0) {
        //                 setAllCity(response.data)
        //                 response.data.map((item) => {
        //                     option.push({
        //                         label: `${item.sub_district}, ${item.district}, ${item.province}`,
        //                         value: item.id_destination,
        //                         zip_code: item.zip_code
        //                     })
        //                 })
        //             }
        //         })
        //         .catch(err => console.log(err))

        //     setOptionCity(option)
        //     try {
        //         // Kompresi data dan simpan di localStorage
        //         const compressedData = LZString.compressToBase64(JSON.stringify(option));
        //         localStorage.setItem('_destination', compressedData);
        //     } catch (error) {
        //         console.error('Error during compression and storage:', error);
        //     }
        // }

        const getMemberData = async (idMember) => {
            const param = new URLSearchParams()
            param.append('id_member', profile.id_member)
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/member.php/?index=2`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    if (response.data.state === 200) {
                        setMember(response.data.data)
                    }
                })
        }

        // getMemberData(profile.id_member)
        // if (localStorage.getItem('_destination') == null) {
        //     generateCityOption()
        // }
    }, [profile])

    useEffect(() => {
        const getStatusMember = async (idCustomer) => {
            const param = new URLSearchParams()
            param.append('id_customer', idCustomer)

            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/order.php/?index=13`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(response => {
                    if (response.data.state === 200) {
                        setAllowReg(response.data.data.status)
                        setFirstPoint(response.data.data.first_point)
                    }
                })
        }

        const validateAddingAddress = async (idCust) => {
            const param = new URLSearchParams()
            param.append('id_customer', idCust)

            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/customer.php/?index=10`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(res => {
                    if (res.data.state === 200) {
                        setAddressState(res.data.data)
                    }
                })
        }


        getStatusMember(idCustomer)
        validateAddingAddress(idCustomer)

    }, [idCustomer])

    useEffect(() => {
        setImageProf(`https://ui-avatars.com/api/?name=${profile.first_name}+${profile.last_name}`)
    }, [profile])

    useEffect(() => {
        const generateDestinationOption = async () => {
            let option = []
            dataDestinasi.map((item, index) => {
                option.push({
                    label: `${item.sub_district}, ${item.district}, ${item.city}, ${item.province}`,
                    value: item.id_destination,
                    zip_code: item.zip_code
                })
            })
            setOptionCity(option)
        }
        generateDestinationOption()
        window.scrollTo(0, 0)
    }, [])

    return (
        <section>
            <Container style={windowWidth < 600 ? { paddingTop: "10vh", minHeight: "100vh" } : { paddingTop: "15vh", minHeight: "100vh" }}>
                <Row>
                    <Col md={12} className="mb-3">
                        <Alert className="text-start" variant="secondary" show={alertJoin} onClose={() => closeAlertJoin()} dismissible>
                            You cannot register as a member at this time, to register as a member you must make a minimum transaction of Rp. 1,500,000 not including shipping costs,
                            on the same day or a maximum of 1 day back and without any last transaction canceled.
                            for more detailed, you can click here <span className="text-primary" style={{ cursor: 'pointer' }} onClick={() => setTermMember(true)}>Term of Membership</span>
                        </Alert>
                    </Col>
                </Row>

                <Modal show={termMember} backdrop='static' keyboard={false} onHide={hideTermMember} size="md">
                    <Modal.Header closeButton><span className="fs-5">Term of Membership</span></Modal.Header>
                    <Modal.Body>
                        <TermMember />
                    </Modal.Body>
                </Modal>

                <Modal show={modalAddress} onHide={closeAddressForm} backdrop='static' keyboard={false} centered >
                    <Modal.Header closeButton>Add Address</Modal.Header>
                    <Modal.Body>
                        <AddressForm showModal={setModalAddress} getUserAddress={getCustomerAddress} isFirstAddress={true} isCashier={cart.customer?.is_cashier} />
                    </Modal.Body>
                </Modal>

                <Modal show={modalAddressEdit} onHide={closeAddressFormEdit} backdrop='static' keyboard='false' centered>
                    <Modal.Header closeButton>Edit Shipping Address</Modal.Header>
                    <Modal.Body>
                        <AddressForm
                            showModal={setModalAddressEdit}
                            getUserAddress={getCustomerAddress}
                            isFirstAddress={false}
                            editData={selectedAddressEdit}
                            setUserAddress={setUserAddress}
                            isCashier={cart.customer?.is_cashier ?? "0"}
                        />
                    </Modal.Body>
                </Modal>

                <Modal show={joinForm} backdrop='static' keyboard={false} onHide={hideJoinForm} size="md">
                    <Modal.Header closeButton><span className="fs-5">Join Membership</span></Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={12} xs={12}>
                                <Form onSubmit={(e) => handleClickJoin(e, firstPoint)} >
                                    <Row className="mb-5">
                                        <Col md={6} xs={12} className="mb-2">
                                            <Form.Group>
                                                <Form.Label>Firstname</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    minLength={2}
                                                    defaultValue={profile.first_name}
                                                    readOnly
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} xs={12} className="mb-2">
                                            <Form.Group>
                                                <Form.Label>Lastname</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    minLength={2}
                                                    defaultValue={profile.last_name}
                                                    readOnly
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} xs={12} className="mb-2">
                                            <Form.Group>
                                                <Form.Label>Phone</Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text id="basic-addon1">+62</InputGroup.Text>
                                                    <Form.Control
                                                        type="text"
                                                        minLength={10}
                                                        defaultValue={phone}
                                                        onChange={(e) => handleChangePhoneNumber(e)}
                                                        required
                                                    />
                                                </InputGroup>
                                                <Form.Text>This must be valid or we won't be able to contact you</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} xs={12} className="mb-2">
                                            <Form.Group>
                                                <Form.Label>Identification</Form.Label>
                                                <div className=" input-group mb-3">
                                                    <Form.Select size="sm" style={{ maxWidth: '4.6rem' }} onChange={(e) => setIden(e.target.value)} maxLength={16} minLength={12} required>
                                                        <option value="KTP">KTP</option>
                                                        <option value="SIM">SIM</option>
                                                    </Form.Select>
                                                    <Form.Control
                                                        type="text"
                                                        minLength={10}
                                                        defaultValue={idenNumber}
                                                        onChange={(e) => handleChangeIndeNumber(e)}
                                                        required
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col md={12} xs={12} className="mb-2">
                                            <Form.Group>
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control type="text" maxLength={100} minLength={10} onChange={(e) => setAddr(e.target.value)} required />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12} xs={12} className="mb-2">
                                            <Form.Group>
                                                <Form.Label>City</Form.Label>
                                                <AsyncSelect
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    isLoading={isLoadOption}
                                                    loadOptions={promiseOptionsCity}
                                                    onChange={(value, action) => {
                                                        setCity((value) ? value.label : null)
                                                        getZipCode((value) ? value.value : null)
                                                    }}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12} xs={12} className="mt-4">
                                            <Form.Group>
                                                <Form.Check
                                                    label="I believe the information I filled in is correct and I am responsible for all of that"
                                                    defaultChecked={checkCorrect}
                                                    onChange={(e) => setCheckCorrect(e.target.checked)}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12} xs={12} className="mt-1">
                                            <Form.Group>
                                                <Form.Check label={
                                                    <>
                                                        I agree to the existing &nbsp;
                                                        <Link onClick={() => { setTermMember(true); setJoinForm(false) }}>membership terms</Link>
                                                    </>
                                                }
                                                    onChange={(e) => setCheckTerm(e.target.checked)}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Button content="Join Now" fluid />
                                        </Col>
                                    </Row>

                                </Form>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
                {
                    (selectedOrder) &&
                    <Modal show={orderDetail} backdrop='static' keyboard={false} onHide={hideOrderDetail} size="lg" fullscreen={windowWidth < 1000 ? true : false}>
                        <Modal.Header closeButton>
                            <span className="fs-5">{(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) ? 'Delivery Order' : 'Pick Up Order'} Detail</span>
                        </Modal.Header>
                        <Modal.Body style={{ backgroundColor: "whitesmoke" }}>
                            {(shippingDetailLoader || warehouseDetailLoader) && (
                                <Dimmer active={shippingDetailLoader} inverted>
                                    <Loader>Loading Data</Loader>
                                </Dimmer>
                            )}
                            <div style={{ border: 1, borderRadius: 5, backgroundColor: "white", padding: 20, marginBottom: 12 }}>
                                <Row>
                                    <Col md={12} className="mb-3">
                                        <Row>
                                            <Col md={12}>
                                                {/* <Accordion>
                                                    <Accordion.Title
                                                        style={{ paddingTop: 0 }}
                                                        active={activeIndex}
                                                        onClick={(e) => handleClickAccord(e)}
                                                    >
                                                        <Row className="d-flex">
                                                            <Col xs={6} sm={6} md={6}>
                                                                <div><Label size="mini" color="orange">{selectedOrder.order_state}</Label></div>
                                                            </Col>
                                                            {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) && (
                                                                <Col xs={6} sm={6} md={6}>
                                                                    <div className="text-end" onClick={() =>
                                                                        !openTrk ?
                                                                            // trackingJNE(awbNumber)
                                                                            trackingJNE(shippingDetail[selectedOrder.id_warehouse]?.no_resi !== null ? shippingDetail[selectedOrder.id_warehouse]?.no_resi : awbNumber)
                                                                            : setOpenTrk(false)
                                                                    }>
                                                                        <>
                                                                            <span>Tracking</span>
                                                                            <span className="text-muted"> (Click here)</span>
                                                                            <Icon name='dropdown' />
                                                                        </>
                                                                    </div>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Accordion.Title>
                                                    <Accordion.Content active={activeIndex} className="text-start">
                                                        <Segment>
                                                            <section className="timeline">
                                                                <ul>
                                                                    {
                                                                        (history) ?
                                                                            history.map((item, i) => {
                                                                                return (
                                                                                    <li>
                                                                                        <Row className="">
                                                                                            <Col xs={12}>
                                                                                                <div className="fw-bold">{item.date}</div>
                                                                                                <div style={windowWidth < 600 ? { width: '15rem' } : { width: '100%' }}>{item.desc}</div>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </li>
                                                                                )
                                                                            })
                                                                            : <>
                                                                                <p>Message: <i>{typeof awbResponse !== 'undefined' ? awbResponse : 'Resi not generate yet'}</i></p>
                                                                                <p>There is no tracking data yet, it is possible that the AWB has not been input by the agent. </p>
                                                                            </>
                                                                    }
                                                                </ul>
                                                            </section>
                                                        </Segment>
                                                    </Accordion.Content>
                                                </Accordion> */}
                                                
                                                {/*
                                                <Row className="d-flex justify-content-between">
                                                    <Col xs={6} sm={6} md={6}>
                                                        <div><Label size="mini" color="orange">{selectedOrder.order_state}</Label></div>
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6}>
                                                        <div className="text-end">JNE Tracking <a href="https://jne.co.id/tracking-package" target="_blank" rel="noopener noreferrer">Here</a> </div>
                                                    </Col>
                                                </Row>
                                                */}
                                                
                                                
                                                {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) && (
                                                    //Tracking JNE id_courier = 1 -> JNE atau bisa courir_name = 'JNE'
                                                    //selectedOrder.courier_name === 'JNE' || selectedOrder.id_courier === 1 ? (
                                                    selectedOrder.id_courier === '1' ? (
                                                        <Accordion>
                                                            <Accordion.Title
                                                                style={{ paddingTop: 0 }}
                                                                active={activeIndex}
                                                                onClick={(e) => handleClickAccord(e)}
                                                            >
                                                                <Row className="d-flex">
                                                                    <Col xs={6} sm={6} md={6}>
                                                                        <div><Label size="mini" color="orange">{selectedOrder.order_state}</Label></div>
                                                                    </Col>
                                                                    {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) && (
                                                                        <Col xs={6} sm={6} md={6}>
                                                                            <div className="text-end" onClick={() =>
                                                                                !openTrk ?
                                                                                    // trackingJNE(awbNumber)
                                                                                    trackingJNE(shippingDetail[selectedOrder.id_warehouse]?.no_resi !== null ? shippingDetail[selectedOrder.id_warehouse]?.no_resi : awbNumber,
                                                                                        shippingDetail[selectedOrder.id_warehouse]?.id_order
                                                                                    )
                                                                                    : setOpenTrk(false)
                                                                            }>
                                                                                <>
                                                                                    <span>Tracking</span>
                                                                                    <span className="text-muted"> (Click here)</span>
                                                                                    <Icon name='dropdown' />
                                                                                </>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                </Row>
                                                            </Accordion.Title>
                                                            <Accordion.Content active={activeIndex} className="text-start">
                                                                <Segment>
                                                                    <section className="timeline mt-4">
                                                                        <ul>
                                                                            {
                                                                                (history) ?
                                                                                    history.map((item, i) => {
                                                                                        return (
                                                                                            <li>
                                                                                                <Row className="">
                                                                                                    <Col xs={12}>
                                                                                                        <div className="fw-bold">{item.date}</div>
                                                                                                        <div style={windowWidth < 600 ? { width: '15rem' } : { width: '100%' }}>{item.desc}</div>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                ) 
                                                                                :
                                                                                (loadingTracking) ? 
                                                                                    <p>Please wait... </p>
                                                                                : 
                                                                                <>
                                                                                    <p>Message: <i>{typeof awbResponse !== 'undefined' ? awbResponse : 'Resi not generate yet'}</i></p>
                                                                                    <p>There is no tracking data yet, it is possible that the AWB has not been input by the agent. </p>
                                                                                </>
                                                                            }
                                                                        </ul>
                                                                    </section>
                                                                </Segment>
                                                            </Accordion.Content>
                                                        </Accordion>
                                                    ) 
                                                    :
                                                    //Tracking PAXEL 
                                                    //Tracking PAXEL id_courier = 3 -> PAXEL atau bisa courir_name = 'PAXEL'
                                                    //selectedOrder.courier_name === 'PAXEL' || selectedOrder.id_courier === 3 ? (
                                                    selectedOrder.id_courier === '3' ? (
                                                        <Accordion>
                                                            <Accordion.Title
                                                                style={{ paddingTop: 0 }}
                                                                active={activeIndex}
                                                                onClick={(e) => handleClickAccord(e)}
                                                            >
                                                                <Row className="d-flex">
                                                                    <Col xs={6} sm={6} md={6}>
                                                                        <div><Label size="mini" color="orange">{selectedOrder.order_state}</Label></div>
                                                                    </Col>
                                                                    {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) && (
                                                                        <Col xs={6} sm={6} md={6}>
                                                                            <div className="text-end" 

                                                                                onClick={() =>
                                                                                !openTrk
                                                                                    //? trackingPaxel(shippingDetail[selectedOrder.id_warehouse]?.no_resi !== null ? shippingDetail[selectedOrder.id_warehouse]?.no_resi : awbNumber,
                                                                                    //    shippingDetail[selectedOrder.id_warehouse]?.id_order
                                                                                    //)
                                                                                    ? trackingPaxel('CO.HOOPS-20260422-1-BT2XUF')
                                                                                    : setOpenTrk(false)
                                                                                }>
                                                                                    
                                                                                <>
                                                                                    <span>Tracking PAXEL</span>
                                                                                    <span className="text-muted"> (Click here)</span>
                                                                                    <Icon name='dropdown' />
                                                                                </>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                </Row>
                                                            </Accordion.Title>
                                                            <Accordion.Content active={activeIndex} className="text-start">
                                                                <Segment>
                                                                    <section className="timeline">
                                                                        { history && (
                                                                                <>
                                                                                <div style={{justifySelf: 'end'}}>
                                                                                    <Button color="orange" onClick={() => setShowMap(!showMap)}>
                                                                                        See Map
                                                                                    </Button>
                                                                                </div>
                                                                                {showMap && (
                                                                                    <div style={{ marginTop: "10px" }}>
                                                                                        <TrackingMap data={fullDataAWB} />
                                                                                    </div>
                                                                                )}
                                                                                {/* 
                                                                                <div>
                                                                                    <TrackingMap data={fullDataAWB} />
                                                                                </div>
                                                                                */}
                                                                                </>
                                                                            )
                                                                        }
                                                                        <ul className="mt-4">
                                                                            {
                                                                                (history) ?
                                                                                    history.map((item, i) => {
                                                                                        return (
                                                                                            <li>
                                                                                                <Row className="">
                                                                                                    <Col xs={12}>
                                                                                                        <div className="fw-bold">{item.date}</div>

                                                                                                        <div style={windowWidth < 600 ? { width: '15rem' } : { width: '100%' }}>
                                                                                                            {item.desc}
                                                                                                        </div>
                                                                                                        
                                                                                                        { item.note != "-" && (
                                                                                                            <div style={windowWidth < 600 ? { width: '15rem' } : { width: '100%' }}>
                                                                                                                <div style={{
                                                                                                                    backgroundColor: '#fff3cd', // kuning soft (bootstrap warning light)
                                                                                                                    color: '#664d03',
                                                                                                                    padding: '8px 12px',
                                                                                                                    borderRadius: '6px',
                                                                                                                    border: '1px solid #ffe69c',
                                                                                                                    marginTop: '6px',
                                                                                                                    fontSize: '0.9rem',
                                                                                                                    marginLeft: '0px',
                                                                                                                    width: '100%' 
                                                                                                                }}>
                                                                                                                    <p style={{fontWeight: '600'}}>Note : </p>
                                                                                                                    {item.note}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </li>
                                                                                        )
                                                                                    })
                                                                                :
                                                                                (loadingTracking) ? 
                                                                                    <p>Please wait... </p>
                                                                                : <>
                                                                                    <p>Message: <i>{typeof awbResponse !== 'undefined' ? awbResponse : 'Resi not generate yet'}</i></p>
                                                                                    <p>There is no tracking data yet. </p>
                                                                                </>
                                                                            }
                                                                        </ul>
                                                                    </section>
                                                                </Segment>
                                                            </Accordion.Content>
                                                        </Accordion>
                                                    ) 
                                                    : null
                                                )}

                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12}>
                                        <Row>
                                            <Col xs={6} sm={6} md={6}>Order Number</Col>
                                            <Col xs={6} sm={6} md={6} className="text-end fw-bold">{selectedOrder.id_order}</Col>
                                        </Row>
                                        {
                                            !shippingDetailLoader && shippingDetail !== null ? 
                                                <Row>
                                                    <Col xs={6} sm={6} md={6}>Shipping Number</Col>
                                                    <Col xs={6} sm={6} md={6} className="text-end fw-bold">{shippingDetail[selectedOrder.id_warehouse]?.no_resi}</Col>
                                                </Row>
                                            : <></>
                                        }
                                        <Row>
                                            <Col xs={6} sm={6} md={6}>Transaction Date</Col>
                                            <Col xs={6} sm={6} md={6} className="text-end fw-bold">{new Date(selectedOrder.order_date).toLocaleDateString('en-US', formatLongDate)}</Col>
                                        </Row>
                                        {selectedOrder.id_warehouse !== null ?
                                            <Row className="text-secondary">
                                                <Col xs={6} sm={6} md={6}>Warehouse</Col>
                                                <Col xs={6} sm={6} md={6} className="text-end fw-bold">
                                                    {!warehouseDetailLoader ? (
                                                        warehouseDetailData
                                                            ? `${warehouseDetailData[selectedOrder.id_warehouse]?.name}, ${formatIndonesianCity(capitalizeWords(warehouseDetailData[selectedOrder.id_warehouse]?.city)) || 'Unknown Warehouse'}`
                                                            : 'Unknown Warehouse'
                                                    ) : (
                                                        <span className=''>
                                                            <Placeholder style={{ width: '50%' }}>&nbsp;</Placeholder>
                                                        </span>
                                                    )}

                                                </Col>
                                            </Row>
                                            : ''
                                        }
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ border: 1, borderRadius: 5, backgroundColor: "white", padding: 20, marginBottom: 12 }}>
                                <Row className="pb-4">
                                    <div className="fw-bold mb-2">
                                        Product Details
                                        {/* {
                                            selectedOrder.id_warehouse !== null && warehouseDetailData && !warehouseDetailLoader && (
                                                ` from 
                                                    ${
                                                        capitalizeWords(warehouseDetailData[selectedOrder?.id_warehouse]?.name) || 'Unknown Warehouse'
                                                    }, 
                                                    ${
                                                        capitalizeWords(formatIndonesianCity(warehouseDetailData[selectedOrder?.id_warehouse]?.city)) || 'Unknown City'
                                                    }
                                                `
                                            )
                                        } */}
                                    </div>
                                    <Col md={9} className="border-end">
                                        {
                                            selectedOrder.product_details.map((item, i) => (
                                                <Stack direction="horizontal" gap={2} className="mb-3" key={i}>
                                                    <Image src={item.image_order ? item.image_order : 'https://via.placeholder.com/500x400.png'} width={64} rounded />
                                                    <Stack direction="vertical">
                                                        <div className="fw-bold">{item.product_name || item.name_order}</div>
                                                        <div>
                                                            <span className="me-2">{global.IDR.format(item.total_price_order)}</span>
                                                            {/* <span className="me-3 text-muted"><s>{global.IDR.format(item.price)}</s></span> */}
                                                            <div>
                                                                <span className="me-3">Qty: {item.qty_order}</span>
                                                                <span className="me-3">Size: {item.size_order}</span>
                                                            </div>
                                                        </div>
                                                    </Stack>
                                                </Stack>
                                            ))
                                        }

                                    </Col>
                                    <Col md={3} className="align-self-center">
                                        <Row className="text-center">
                                            <Col md={12} >
                                                <div>
                                                    {
                                                        selectedOrder.id_warehouse !== null ? (
                                                            <>
                                                                Total Order Product <br />from {
                                                                    !warehouseDetailLoader
                                                                        ? (
                                                                            warehouseDetailData
                                                                                ? warehouseDetailData[selectedOrder.id_warehouse]?.name
                                                                                : 'Unknown Warehouse'
                                                                        ) : (
                                                                            <span className='me-4'>
                                                                                <Placeholder>&nbsp;</Placeholder>
                                                                            </span>
                                                                        )
                                                                } Warehouse
                                                            </>
                                                        ) : 'Total Order'
                                                    }
                                                </div>
                                                <div className="fw-bold">
                                                    {
                                                        selectedOrder.id_warehouse !== null && shippingDetail !== null && (selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0)
                                                            ? global.IDR.format(parseFloat(shippingDetail[selectedOrder.id_warehouse]?.total_price))
                                                            : global.IDR.format(selectedOrder.total_payment)
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) && (
                            <div style={{ border: 1, borderRadius: 5, backgroundColor: "white", padding: 20, marginBottom: 12 }}>
                                <Row>
                                    <div className="fw-bold mb-2">Delivery Info</div>
                                    <Col md={12}>
                                        <Row className="mb-2">
                                            <Col xs={4} sm={2} md={2}>Courier</Col>
                                            <Col xs={1} sm={1} md={1} className="text-end">:</Col>
                                            <Col xs={7} sm={9} md={9} className="fw-bold">
                                                {
                                                    selectedOrder.id_warehouse !== null && shippingDetail !== null ?
                                                        `${shippingDetail[selectedOrder.id_warehouse]?.courier_name} - ${shippingDetail[selectedOrder.id_warehouse]?.service_display}`
                                                        : `${selectedOrder.courier_name} - ${selectedOrder.id_service}`
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col xs={4} sm={2} md={2}>Resi Number</Col>
                                            <Col xs={1} sm={1} md={1} className="text-end">:</Col>
                                            <Col xs={7} sm={9} md={9} className="fw-bold">
                                                {
                                                    selectedOrder.id_warehouse !== null && shippingDetail !== null ?
                                                        shippingDetail[selectedOrder.id_warehouse]?.no_resi
                                                        : selectedOrder.no_resi
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col xs={4} sm={2} md={2}>Address</Col>
                                            <Col xs={1} sm={1} md={1} className="text-end">:</Col>
                                            <Col xs={7} sm={9} md={9} className="fw-bold">
                                                <Stack direction="vertical">
                                                    <Stack direction="horizontal" gap={3} className="mb-2">
                                                        <div>{selectedOrder.recipient}</div>
                                                        <div><Label size="tiny">{selectedOrder.address_label}</Label></div>
                                                    </Stack>
                                                    <div className="fw-light">{selectedOrder.phone}</div>
                                                    <div className="fw-light"><span>{selectedOrder.address_detail}</span> <span>{selectedOrder.address_detail_dua}</span>,</div>
                                                    <div className="fw-light">{selectedOrder.sub_district}, {selectedOrder.district}, {selectedOrder.city}</div>
                                                    <div className="fw-light">{selectedOrder.province} {selectedOrder.zip}</div>
                                                </Stack>
                                            </Col>
                                        </Row>
                                        {selectedOrder.id_warehouse !== null && shippingDetail !== null && (
                                            <>
                                                <div className="mb-2 fw-bold text-secondary">
                                                    Shipping Detail from {
                                                        !warehouseDetailLoader ? (
                                                            warehouseDetailData 
                                                            ? warehouseDetailData[selectedOrder.id_warehouse]?.name
                                                            : 'Unknown Warehouse'
                                                        ) : (
                                                            <span className=''>
                                                                <Placeholder style={{width: '50%'}}>&nbsp;</Placeholder>
                                                            </span>
                                                        )
                                                    }
                                                </div>
                                                <Row className="mb-2 text-secondary">
                                                    <Col xs={6} sm={6} md={6}>
                                                        Weight
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6} className="fw-bold text-end text-secondary">
                                                        {shippingDetail[selectedOrder.id_warehouse]?.weight + ' KG' || '-'}
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2 text-secondary">
                                                    <Col xs={6} sm={6} md={6}>
                                                        Shipping Cost
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6} className="fw-bold text-end text-secondary">
                                                        {global.IDR.format(shippingDetail[selectedOrder.id_warehouse]?.shipping_cost) || '-'}
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2 text-secondary">
                                                    <Col xs={6} sm={6} md={6}>
                                                        Insurance
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6} className="fw-bold text-end text-secondary">
                                                        {global.IDR.format(shippingDetail[selectedOrder.id_warehouse]?.shipping_insurance) || '-'}
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2 text-secondary">
                                                    <Col xs={6} sm={6} md={6}>
                                                        Total Shipping
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6} className="fw-bold text-end text-secondary">
                                                        {global.IDR.format(parseFloat(shippingDetail[selectedOrder.id_warehouse]?.shipping_cost) + parseFloat(shippingDetail[selectedOrder.id_warehouse]?.shipping_insurance)) || '-'}
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                            )}
                            {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) &&
                            selectedOrder.id_warehouse !== null && shippingDetail !== null && (
                                <div style={{ border: 1, borderRadius: 5, backgroundColor: "white", padding: 20, marginBottom: 12 }}>
                                    <Row className="mb-2 text-secondary">
                                        <Col xs={6} sm={6} md={6}>
                                            Total Price from {
                                                !warehouseDetailLoader ? (
                                                    warehouseDetailData
                                                    ? warehouseDetailData[selectedOrder.id_warehouse]?.name || 'Unknown Warehouse'
                                                    : 'Unknown Warehouse'
                                                ) : (
                                                    <span className='me-4'>
                                                        <Placeholder>&nbsp;</Placeholder>
                                                    </span>
                                                )
                                            }
                                        </Col>
                                        <Col xs={6} sm={6} md={6} className="fw-bold text-end">
                                            {global.IDR.format(parseFloat(shippingDetail[selectedOrder.id_warehouse]?.shipping_cost) + parseFloat(shippingDetail[selectedOrder.id_warehouse]?.shipping_insurance) + parseFloat(shippingDetail[selectedOrder.id_warehouse]?.total_price)) || '-'}
                                        </Col>
                                    </Row>
                                </div>
                            )}
                            <div style={{ border: 1, borderRadius: 5, backgroundColor: "white", padding: 20, marginBottom: 12 }}>
                                <Row>
                                    <div className="fw-bold mb-2">Payment Summarize</div>
                                    <Col xs={6} sm={6} md={6}>
                                        <div>Payment Method</div>
                                    </Col>
                                    <Col xs={6} sm={6} md={6}>
                                        <div className="fw-bold text-uppercase text-end">
                                            {selectedOrder.payment_method} - {selectedOrder.bank}
                                        </div>
                                    </Col>
                                    <Col md={12}><Divider clearing /></Col>
                                    {shippingDetail && Object.entries(shippingDetail)
                                        .sort(([a], [b]) => {
                                            if (a === 'WH0006') return -1;
                                            if (b === 'WH0006') return 1;
                                            return a.localeCompare(b);
                                        }).map(([warehouseId, detail], i) => (
                                            <>
                                                <Col xs={6} sm={6} md={6}>
                                                    <div className="text-secondary">
                                                        Total Item from{' '}{capitalizeWords(warehouseDetailData[warehouseId]?.name) || 'Unknown Warehouse'}
                                                    </div>
                                                </Col>
                                                <Col xs={6} sm={6} md={6}>
                                                    <div className="fw-bold text-uppercase text-end text-secondary">
                                                        {global.IDR.format(detail.total_price)}
                                                    </div>
                                                </Col>
                                            </>
                                        ))}
                                    <Col xs={6} sm={6} md={6}>
                                        <div>Grand Total Item</div>
                                    </Col>
                                    <Col xs={6} sm={6} md={6} className="fw-bold text-end">{global.IDR.format(selectedOrder.total_price)}</Col>
                                    <Col md={12}><Divider clearing /></Col>
                                    <Col xs={6} sm={6} md={6}>
                                        <div>Voucher</div>
                                    </Col>
                                    <Col xs={6} sm={6} md={6} className="fw-bold text-end">{global.IDR.format(selectedOrder.total_voucher)}</Col>
                                    {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) && (
                                        <>
                                            <Col xs={6} sm={6} md={6}>
                                                <div>Shipping Voucher</div>
                                            </Col>
                                            <Col xs={6} sm={6} md={6} className="fw-bold text-end">{global.IDR.format(selectedOrder.shipping_voucher)}</Col>
                                        </>
                                    )}
                                    <Col md={12}><Divider clearing /></Col>
                                    {shippingDetail && Object.entries(shippingDetail).sort(([a], [b]) => {
                                        if (a === 'WH0006') return -1;
                                        if (b === 'WH0006') return 1;
                                        return a.localeCompare(b);
                                    }).map(([warehouseId, detail], i) => (
                                        <>
                                            <Col xs={6} sm={6} md={6}>
                                                <div className="text-secondary">
                                                    Total Shipping from{' '}{capitalizeWords(warehouseDetailData[warehouseId]?.name) || 'Unknown Warehouse'}
                                                </div>
                                            </Col>
                                            <Col xs={6} sm={6} md={6}>
                                                <div className="fw-bold text-uppercase text-end text-secondary">
                                                    {global.IDR.format(detail.shipping_cost)}
                                                </div>
                                            </Col>
                                        </>
                                    ))}
                                    {(selectedOrder.isPickUp === null || selectedOrder.isPickUp == 0) && (
                                        <>
                                            <Col xs={6} sm={6} md={6}>
                                                <div>Grand Delivery Cost</div>
                                            </Col>
                                            {selectedOrder.shipping_voucher > 0 ?
                                                <Col xs={6} sm={6} md={6} className="text-end"><span>({global.IDR.format(parseFloat(selectedOrder.shipping_voucher) + parseFloat(selectedOrder.courier_cost))})</span>&nbsp;<span className="fw-bold text-end">{global.IDR.format(selectedOrder.courier_cost)}</span></Col>
                                                :
                                                <Col xs={6} sm={6} md={6} className="text-end fw-bold">{global.IDR.format(selectedOrder.courier_cost)}</Col>
                                            }
                                            <Col md={12}><Divider clearing /></Col>
                                            {shippingDetail && Object.entries(shippingDetail).sort(([a], [b]) => {
                                                if (a === 'WH0006') return -1;
                                                if (b === 'WH0006') return 1;
                                                return a.localeCompare(b);
                                            }).map(([warehouseId, detail], i) => (
                                                <>
                                                    <Col xs={6} sm={6} md={6}>
                                                        <div className="text-secondary">
                                                            Total Insurance from{' '}{capitalizeWords(warehouseDetailData[warehouseId]?.name) || 'Unknown Warehouse'}
                                                        </div>
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6}>
                                                        <div className="fw-bold text-secondary text-uppercase text-end">
                                                            {global.IDR.format(detail.shipping_insurance)}
                                                        </div>
                                                    </Col>
                                                </>
                                            ))}
                                            <Col xs={6} sm={6} md={6}>
                                                <div>Grand Shipping Insurance</div>
                                            </Col>
                                            <Col xs={6} sm={6} md={6} className="text-end fw-bold">{global.IDR.format(selectedOrder.asuransi)}</Col>
                                            <Col md={12}><Divider clearing /></Col>
                                        </>
                                    )}
                                    <Col xs={6} sm={6} md={6}>
                                        <div>Grand Total Order</div>
                                    </Col>
                                    <Col xs={6} sm={6} md={6} className="fw-bold text-end">{global.IDR.format(selectedOrder.total_payment)}</Col>
                                </Row>
                            </div>
                        </Modal.Body>
                    </Modal>
                }
                <Row className="text-start">
                    <Col xs={12} sm={12} md={12} lg={4} xl={3}>
                        <Menu vertical fluid size="large" className="mb-3" style={{ fontSize: '1.4rem', fontFamily: 'Poppins, sans-serif' }}>
                            <Menu.Item>
                                <Menu.Header>
                                    <Stack direction="horizontal" gap={3}>
                                        <Image src={profile.avatar !== '' ? profile.avatar : imageProf} height={50} width={50} rounded />
                                        <div className="fs-5">
                                            <Stack direction="vertical" gap={2}>
                                                <div className="text-capitalize">{profile && profile.first_name + ' ' + profile.last_name}</div>
                                                {/* <div><Label size="mini">{profile && (profile.isMember == "Y") ? "Member" : "Customer"}</Label></div> */}
                                                <div>
                                                    {profile && profile.isMember == "Y" ?
                                                        <>
                                                            <Stack direction="horizontal" gap={2}>
                                                                <Label >Customer</Label>
                                                                <Label color="orange">Member</Label>
                                                            </Stack>
                                                        </>
                                                        :
                                                        <Label size="mini" color="orange">Customer</Label>
                                                    }
                                                </div>
                                            </Stack>
                                        </div>
                                    </Stack>
                                </Menu.Header>
                            </Menu.Item>
                            <Menu.Item>
                                <Menu.Menu>
                                    <Menu.Item
                                        name="profile"
                                        active={activeMenu === "profile"}
                                        onClick={() => handlMenuClick("profile")}
                                    />
                                    <Menu.Item
                                        name="transaction"
                                        active={activeMenu === "transaction"}
                                        onClick={() => handlMenuClick("transaction")}
                                    />
                                    <Menu.Item
                                        name="wishlist"
                                        active={activeMenu === "wishlist"}
                                        onClick={() => handlMenuClick("wishlist")}
                                    />
                                    {/* <Menu.Item
                                        name="membership"
                                        active={activeMenu === "membership"}
                                        onClick={() => handlMenuClick("membership")}
                                    /> */}
                                    <Menu.Item
                                        name="address"
                                        active={activeMenu === "address"}
                                        onClick={() => handlMenuClick("address")}
                                    />
                                </Menu.Menu>
                            </Menu.Item>
                        </Menu>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={8} xl={9}>
                        <RenderedContent />
                    </Col>
                </Row>

            </Container>
        </section>
    )
}

export default Profile